/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Widget_Action_CopiedInputs */
/** @typedef {{}} Widget_Bag_ChangeInputs */
/** @typedef {{}} Widget_Bag_CheckoutInputs */
/** @typedef {{}} Widget_Bag_CloseInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Bag_DecreaseInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Bag_IncreaseInputs */
/** @typedef {{}} Widget_Bag_LabelInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Bag_OpenInputs */
/** @typedef {{}} Widget_Bag_RemoveInputs */
/** @typedef {{}} Widget_Bag_SavingsInputs */
/** @typedef {{}} Widget_Bag_ShippingInputs */
/** @typedef {{}} Widget_Bag_Shipping_ValueInputs */
/** @typedef {{}} Widget_Bag_SubtotalInputs */
/** @typedef {{}} Widget_Bag_SyncedInputs */
/** @typedef {{}} Widget_Bag_TitleInputs */
/** @typedef {{}} Widget_Bag_TotalInputs */
/** @typedef {{}} Widget_Blocks_LoadingInputs */
/** @typedef {{}} Widget_Blocks_PendingInputs */
/** @typedef {{}} Widget_Blocks_Refresh_FailedInputs */
/** @typedef {{}} Widget_Board_OpenInputs */
/** @typedef {{}} Widget_Board_ShowingInputs */
/** @typedef {{}} Widget_Cart_Add_FailedInputs */
/** @typedef {{ total: NonNullable<unknown> }} Widget_Cart_Add_TotalInputs */
/** @typedef {{}} Widget_Cart_AddingInputs */
/** @typedef {{}} Widget_Cart_Adding_ShortInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_All_In_CartInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_AvailableInputs */
/** @typedef {{ to: NonNullable<unknown>, from: NonNullable<unknown> }} Widget_Cart_Change_FailedInputs */
/** @typedef {{}} Widget_Cart_Change_UnconfirmedInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Widget_Cart_ChangesInputs */
/** @typedef {{}} Widget_Cart_Check_AgainInputs */
/** @typedef {{}} Widget_Cart_CheckingInputs */
/** @typedef {{}} Widget_Cart_Checking_ShortInputs */
/** @typedef {{ count: NonNullable<unknown>, available: NonNullable<unknown> }} Widget_Cart_Clamp_AvailableInputs */
/** @typedef {{ count: NonNullable<unknown>, inCart: NonNullable<unknown> }} Widget_Cart_Clamp_In_CartInputs */
/** @typedef {{}} Widget_Cart_DecreaseInputs */
/** @typedef {{}} Widget_Cart_Edit_TitleInputs */
/** @typedef {{}} Widget_Cart_Enter_QuantityInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_In_CartInputs */
/** @typedef {{}} Widget_Cart_IncreaseInputs */
/** @typedef {{}} Widget_Cart_LowestInputs */
/** @typedef {{}} Widget_Cart_MissingInputs */
/** @typedef {{}} Widget_Cart_New_QuantityInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Now_In_CartInputs */
/** @typedef {{ name: NonNullable<unknown>, value: NonNullable<unknown> }} Widget_Cart_Option_HeadingInputs */
/** @typedef {{}} Widget_Cart_QuantityInputs */
/** @typedef {{}} Widget_Cart_Read_FailedInputs */
/** @typedef {{}} Widget_Cart_Receipt_AddedInputs */
/** @typedef {{ added: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_Receipt_MergedInputs */
/** @typedef {{ added: NonNullable<unknown>, requested: NonNullable<unknown> }} Widget_Cart_Receipt_PartialInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Receipt_QtyInputs */
/** @typedef {{ requested: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_Receipt_ShortInputs */
/** @typedef {{ requested: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_Receipt_Short_MoreInputs */
/** @typedef {{}} Widget_Cart_Receipt_UpdatedInputs */
/** @typedef {{}} Widget_Cart_RejectedInputs */
/** @typedef {{}} Widget_Cart_RetryInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Retry_SetInputs */
/** @typedef {{ options: NonNullable<unknown> }} Widget_Cart_SelectInputs */
/** @typedef {{ variant: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_SummaryInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Summary_DefaultInputs */
/** @typedef {{}} Widget_Cart_UnchangedInputs */
/** @typedef {{}} Widget_Cart_UnconfirmedInputs */
/** @typedef {{}} Widget_Cart_UpdateInputs */
/** @typedef {{}} Widget_Cart_UpdatingInputs */
/** @typedef {{}} Widget_Cart_Updating_ShortInputs */
/** @typedef {{ value: NonNullable<unknown> }} Widget_Cart_Value_Sold_OutInputs */
/** @typedef {{ variant: NonNullable<unknown> }} Widget_Cart_Variant_Sold_OutInputs */
/** @typedef {{}} Widget_Compare_Add_RowInputs */
/** @typedef {{}} Widget_Compare_AskedInputs */
/** @typedef {{ first: NonNullable<unknown>, second: NonNullable<unknown> }} Widget_Compare_CaptionInputs */
/** @typedef {{}} Widget_Compare_DiffersInputs */
/** @typedef {{}} Widget_Compare_FieldInputs */
/** @typedef {{}} Widget_Composer_BusyInputs */
/** @typedef {{}} Widget_Composer_PlaceholderInputs */
/** @typedef {{}} Widget_Composer_SendInputs */
/** @typedef {{}} Widget_Contact_Description_ErrorInputs */
/** @typedef {{}} Widget_Contact_Description_HintInputs */
/** @typedef {{}} Widget_Contact_Description_LabelInputs */
/** @typedef {{}} Widget_Contact_Description_PlaceholderInputs */
/** @typedef {{}} Widget_Contact_DismissInputs */
/** @typedef {{}} Widget_Contact_Email_Error_EmptyInputs */
/** @typedef {{}} Widget_Contact_Email_Error_FormatInputs */
/** @typedef {{}} Widget_Contact_Email_Error_OwnInputs */
/** @typedef {{}} Widget_Contact_Email_FromInputs */
/** @typedef {{}} Widget_Contact_Email_Hint_AccountInputs */
/** @typedef {{}} Widget_Contact_Email_Hint_CheckoutInputs */
/** @typedef {{}} Widget_Contact_Email_LabelInputs */
/** @typedef {{}} Widget_Contact_Email_PlaceholderInputs */
/** @typedef {{}} Widget_Contact_Email_Preview_LabelInputs */
/** @typedef {{}} Widget_Contact_Email_Reply_ToInputs */
/** @typedef {{}} Widget_Contact_Email_SubjectInputs */
/** @typedef {{}} Widget_Contact_Email_ToInputs */
/** @typedef {{}} Widget_Contact_OptionalInputs */
/** @typedef {{}} Widget_Contact_Order_Hint_UnverifiedInputs */
/** @typedef {{}} Widget_Contact_Order_Hint_VerifiedInputs */
/** @typedef {{}} Widget_Contact_Order_LabelInputs */
/** @typedef {{}} Widget_Contact_Order_PlaceholderInputs */
/** @typedef {{}} Widget_Contact_Order_VerifiedInputs */
/** @typedef {{}} Widget_Contact_Product_ViewInputs */
/** @typedef {{ time: NonNullable<unknown> }} Widget_Contact_Products_As_OfInputs */
/** @typedef {{}} Widget_Contact_Products_LegendInputs */
/** @typedef {{}} Widget_Contact_Recipient_LabelInputs */
/** @typedef {{}} Widget_Contact_Reply_NoteInputs */
/** @typedef {{}} Widget_Contact_Request_TypeInputs */
/** @typedef {{}} Widget_Contact_ReviewInputs */
/** @typedef {{}} Widget_Contact_SendInputs */
/** @typedef {{}} Widget_Contact_TitleInputs */
/** @typedef {{}} Widget_Contact_Type_Delivery_IssuesInputs */
/** @typedef {{}} Widget_Contact_Type_Order_CancellationInputs */
/** @typedef {{}} Widget_Contact_Type_Order_ChangesInputs */
/** @typedef {{}} Widget_Contact_Type_Order_StatusInputs */
/** @typedef {{}} Widget_Contact_Type_OtherInputs */
/** @typedef {{}} Widget_Contact_Type_Product_IssuesInputs */
/** @typedef {{}} Widget_Contact_Type_ReturnsInputs */
/** @typedef {{}} Widget_Contact_Type_SubscriptionsInputs */
/** @typedef {{}} Widget_Conversation_LatestInputs */
/** @typedef {{}} Widget_Conversation_MessagesInputs */
/** @typedef {{}} Widget_Drawer_ResizeInputs */
/** @typedef {{}} Widget_Email_Result_Accepted_FactInputs */
/** @typedef {{}} Widget_Email_Result_CheckInputs */
/** @typedef {{}} Widget_Email_Result_EditInputs */
/** @typedef {{}} Widget_Email_Result_EmailInputs */
/** @typedef {{ id: NonNullable<unknown> }} Widget_Email_Result_GroupInputs */
/** @typedef {{}} Widget_Email_Result_NextInputs */
/** @typedef {{}} Widget_Email_Result_Next_BouncedInputs */
/** @typedef {{}} Widget_Email_Result_Next_FailedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Widget_Email_Result_Next_ReplyInputs */
/** @typedef {{}} Widget_Email_Result_Next_SendingInputs */
/** @typedef {{}} Widget_Email_Result_Next_UnknownInputs */
/** @typedef {{}} Widget_Email_Result_RequestInputs */
/** @typedef {{}} Widget_Email_Result_RetryInputs */
/** @typedef {{}} Widget_Email_Result_Sending_ActionInputs */
/** @typedef {{}} Widget_Email_Result_Start_NewInputs */
/** @typedef {{}} Widget_Email_Result_SubmittedInputs */
/** @typedef {{}} Widget_Email_Result_Subtitle_AcceptedInputs */
/** @typedef {{}} Widget_Email_Result_Title_AcceptedInputs */
/** @typedef {{}} Widget_Email_Result_Title_BouncedInputs */
/** @typedef {{}} Widget_Email_Result_Title_DeliveredInputs */
/** @typedef {{}} Widget_Email_Result_Title_FailedInputs */
/** @typedef {{}} Widget_Email_Result_Title_SendingInputs */
/** @typedef {{}} Widget_Email_Result_Title_UnknownInputs */
/** @typedef {{}} Widget_Email_Result_ToInputs */
/** @typedef {{}} Widget_Email_Result_UpdatedInputs */
/** @typedef {{}} Widget_Empty_TitleInputs */
/** @typedef {{}} Widget_Error_Answer_LostInputs */
/** @typedef {{}} Widget_Error_Chat_UnavailableInputs */
/** @typedef {{}} Widget_Error_No_AnswerInputs */
/** @typedef {{}} Widget_Error_Playground_ExpiredInputs */
/** @typedef {{}} Widget_Error_Signin_UnavailableInputs */
/** @typedef {{}} Widget_Evidence_Sold_OutInputs */
/** @typedef {{}} Widget_Evidence_Store_PageInputs */
/** @typedef {{}} Widget_Feedback_CancelInputs */
/** @typedef {{}} Widget_Feedback_DefaultInputs */
/** @typedef {{}} Widget_Feedback_Details_PlaceholderInputs */
/** @typedef {{}} Widget_Feedback_HelpInputs */
/** @typedef {{}} Widget_Feedback_LabelInputs */
/** @typedef {{}} Widget_Feedback_Load_FailedInputs */
/** @typedef {{}} Widget_Feedback_LoadingInputs */
/** @typedef {{}} Widget_Feedback_Network_FailedInputs */
/** @typedef {{}} Widget_Feedback_SendInputs */
/** @typedef {{}} Widget_Feedback_Send_FailedInputs */
/** @typedef {{}} Widget_Feedback_SubmittedInputs */
/** @typedef {{ memberName: NonNullable<unknown> }} Widget_Feedback_Submitted_ByInputs */
/** @typedef {{}} Widget_Feedback_TitleInputs */
/** @typedef {{}} Widget_Footer_Powered_ByInputs */
/** @typedef {{}} Widget_Form_DismissInputs */
/** @typedef {{}} Widget_Generating_CatalogInputs */
/** @typedef {{}} Widget_Generating_DealsInputs */
/** @typedef {{}} Widget_Generating_DetailsInputs */
/** @typedef {{}} Widget_Generating_RacksInputs */
/** @typedef {{}} Widget_Generating_ShelvesInputs */
/** @typedef {{}} Widget_Generating_StillInputs */
/** @typedef {{}} Widget_Generating_StockroomInputs */
/** @typedef {{}} Widget_Header_ClearInputs */
/** @typedef {{}} Widget_Header_CloseInputs */
/** @typedef {{}} Widget_Header_Enter_FullscreenInputs */
/** @typedef {{}} Widget_Header_Enter_SpaceInputs */
/** @typedef {{}} Widget_Header_Exit_FullscreenInputs */
/** @typedef {{}} Widget_Header_Exit_SpaceInputs */
/** @typedef {{}} Widget_Header_MinimizeInputs */
/** @typedef {{}} Widget_Header_StatusInputs */
/** @typedef {{}} Widget_Header_TitleInputs */
/** @typedef {{}} Widget_Launcher_LabelInputs */
/** @typedef {{}} Widget_Loading_ChatInputs */
/** @typedef {{ variant: NonNullable<unknown> }} Widget_Look_In_BagInputs */
/** @typedef {{ label: NonNullable<unknown>, index: NonNullable<unknown>, total: NonNullable<unknown> }} Widget_Look_PositionInputs */
/** @typedef {{ variant: NonNullable<unknown> }} Widget_Look_SelectedInputs */
/** @typedef {{}} Widget_Look_SwapInputs */
/** @typedef {{ role: NonNullable<unknown> }} Widget_Look_Swap_LabelInputs */
/** @typedef {{}} Widget_Message_CopyInputs */
/** @typedef {{}} Widget_Message_DislikeInputs */
/** @typedef {{}} Widget_Message_Feedback_SorryInputs */
/** @typedef {{}} Widget_Message_Feedback_ThanksInputs */
/** @typedef {{}} Widget_Message_ImageInputs */
/** @typedef {{}} Widget_Message_Image_CloseInputs */
/** @typedef {{}} Widget_Message_Image_OpenInputs */
/** @typedef {{}} Widget_Message_Image_UnavailableInputs */
/** @typedef {{}} Widget_Message_LikeInputs */
/** @typedef {{}} Widget_Message_ReplyingInputs */
/** @typedef {{}} Widget_Message_RetryInputs */
/** @typedef {{}} Widget_Message_UndeliveredInputs */
/** @typedef {{}} Widget_Message_UnsupportedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Notice_Now_ViewingInputs */
/** @typedef {{}} Widget_Order_AdjustmentsInputs */
/** @typedef {{}} Widget_Order_Canceled_ItemsInputs */
/** @typedef {{}} Widget_Order_CancellationInputs */
/** @typedef {{}} Widget_Order_Carrier_UnknownInputs */
/** @typedef {{}} Widget_Order_Check_ActionInputs */
/** @typedef {{}} Widget_Order_ContactInputs */
/** @typedef {{}} Widget_Order_Details_LabelInputs */
/** @typedef {{}} Widget_Order_Empty_TitleInputs */
/** @typedef {{}} Widget_Order_Error_InaccessibleInputs */
/** @typedef {{}} Widget_Order_Error_OfflineInputs */
/** @typedef {{}} Widget_Order_Error_Rate_LimitedInputs */
/** @typedef {{}} Widget_Order_Error_UpstreamInputs */
/** @typedef {{}} Widget_Order_Error_VerificationInputs */
/** @typedef {{ time: NonNullable<unknown> }} Widget_Order_Eta_SourceInputs */
/** @typedef {{}} Widget_Order_Eta_UnknownInputs */
/** @typedef {{}} Widget_Order_Event_WaitingInputs */
/** @typedef {{}} Widget_Order_EyebrowInputs */
/** @typedef {{}} Widget_Order_Failed_TitleInputs */
/** @typedef {{}} Widget_Order_Fulfilled_ItemsInputs */
/** @typedef {{}} Widget_Order_Hidden_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_Item_QuantityInputs */
/** @typedef {{}} Widget_Order_Label_CreatedInputs */
/** @typedef {{}} Widget_Order_LoadingInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_FulfillmentsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_RefundsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_ReturnsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_TrackingsInputs */
/** @typedef {{}} Widget_Order_No_ShippingInputs */
/** @typedef {{}} Widget_Order_Not_ReceivedInputs */
/** @typedef {{}} Widget_Order_PaymentInputs */
/** @typedef {{}} Widget_Order_Payment_AuthorizedInputs */
/** @typedef {{}} Widget_Order_Payment_PaidInputs */
/** @typedef {{}} Widget_Order_Payment_Partially_PaidInputs */
/** @typedef {{}} Widget_Order_Payment_Partially_RefundedInputs */
/** @typedef {{}} Widget_Order_Payment_PendingInputs */
/** @typedef {{}} Widget_Order_Payment_RefundedInputs */
/** @typedef {{}} Widget_Order_Payment_VoidedInputs */
/** @typedef {{}} Widget_Order_Pending_ItemsInputs */
/** @typedef {{}} Widget_Order_Progress_LabelInputs */
/** @typedef {{}} Widget_Order_Refund_RecordInputs */
/** @typedef {{}} Widget_Order_RetryInputs */
/** @typedef {{ name: NonNullable<unknown> }} Widget_Order_Return_RecordInputs */
/** @typedef {{}} Widget_Order_Ship_ToInputs */
/** @typedef {{}} Widget_Order_Shipped_ItemsInputs */
/** @typedef {{}} Widget_Order_Shipping_UnknownInputs */
/** @typedef {{}} Widget_Order_StatusInputs */
/** @typedef {{}} Widget_Order_Status_CanceledInputs */
/** @typedef {{}} Widget_Order_Status_DeliveredInputs */
/** @typedef {{}} Widget_Order_Status_Partially_ShippedInputs */
/** @typedef {{}} Widget_Order_Status_ShippedInputs */
/** @typedef {{}} Widget_Order_Status_UnfulfilledInputs */
/** @typedef {{}} Widget_Order_Step_ArrivesInputs */
/** @typedef {{}} Widget_Order_Step_DeliveredInputs */
/** @typedef {{}} Widget_Order_Step_PlacedInputs */
/** @typedef {{}} Widget_Order_Step_ShippedInputs */
/** @typedef {{}} Widget_Order_TotalInputs */
/** @typedef {{}} Widget_Order_TrackInputs */
/** @typedef {{}} Widget_Order_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Order_UnknownInputs */
/** @typedef {{}} Widget_Order_VerifiedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Widget_Order_Verified_DetailInputs */
/** @typedef {{}} Widget_Order_ViewInputs */
/** @typedef {{}} Widget_Orders_Limit_ReachedInputs */
/** @typedef {{}} Widget_Orders_List_LabelInputs */
/** @typedef {{}} Widget_Orders_Load_MoreInputs */
/** @typedef {{}} Widget_Orders_LoadingInputs */
/** @typedef {{}} Widget_Orders_Loading_FirstInputs */
/** @typedef {{}} Widget_Orders_Loading_StatusInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Orders_More_ItemsInputs */
/** @typedef {{}} Widget_Orders_Newest_FirstInputs */
/** @typedef {{ number: NonNullable<unknown> }} Widget_Orders_Order_NumberInputs */
/** @typedef {{}} Widget_Orders_Readable_EmptyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Orders_Show_MoreInputs */
/** @typedef {{}} Widget_Orders_TitleInputs */
/** @typedef {{}} Widget_Peek_OpenInputs */
/** @typedef {{}} Widget_Picker_ConfirmInputs */
/** @typedef {{}} Widget_Picker_ConsumedInputs */
/** @typedef {{}} Widget_Picker_ExitInputs */
/** @typedef {{}} Widget_Picker_FailedInputs */
/** @typedef {{ prompt: NonNullable<unknown> }} Widget_Picker_For_RuleInputs */
/** @typedef {{}} Widget_Picker_HintInputs */
/** @typedef {{}} Widget_Picker_InvalidInputs */
/** @typedef {{}} Widget_Picker_RegionInputs */
/** @typedef {{}} Widget_Picker_ReselectInputs */
/** @typedef {{}} Widget_Picker_RetryInputs */
/** @typedef {{}} Widget_Picker_Rule_GoneInputs */
/** @typedef {{}} Widget_Picker_SaveInputs */
/** @typedef {{}} Widget_Picker_SavingInputs */
/** @typedef {{}} Widget_Picker_Selector_RejectedInputs */
/** @typedef {{}} Widget_Playground_Customer_ActionInputs */
/** @typedef {{}} Widget_Playground_Customer_DescriptionInputs */
/** @typedef {{}} Widget_Playground_Customer_Email_LabelInputs */
/** @typedef {{}} Widget_Playground_Customer_Not_FoundInputs */
/** @typedef {{}} Widget_Preview_ProactiveInputs */
/** @typedef {{}} Widget_Preview_Product_TitleInputs */
/** @typedef {{}} Widget_Proactive_DismissInputs */
/** @typedef {{}} Widget_Product_AddInputs */
/** @typedef {{}} Widget_Product_CartInputs */
/** @typedef {{}} Widget_Product_Load_FailedInputs */
/** @typedef {{ price: NonNullable<unknown> }} Widget_Product_OpeningInputs */
/** @typedef {{}} Widget_Product_Sold_OutInputs */
/** @typedef {{}} Widget_Product_SubscriptionInputs */
/** @typedef {{}} Widget_Replay_Handed_OffInputs */
/** @typedef {{}} Widget_Reply_Card_CurrencyInputs */
/** @typedef {{}} Widget_Reply_Card_DetailsInputs */
/** @typedef {{}} Widget_Reply_Card_ExpiredInputs */
/** @typedef {{}} Widget_Reply_Card_GenericInputs */
/** @typedef {{}} Widget_Reply_Card_Missing_FieldsInputs */
/** @typedef {{}} Widget_Reply_Card_NoticeInputs */
/** @typedef {{}} Widget_Reply_Card_Order_DetailInputs */
/** @typedef {{}} Widget_Reply_Card_Order_ListInputs */
/** @typedef {{}} Widget_Reply_Card_Quick_ActionInputs */
/** @typedef {{}} Widget_Reply_Card_RevokedInputs */
/** @typedef {{}} Widget_Reply_Card_Support_RequestInputs */
/** @typedef {{}} Widget_Reply_Card_VerificationInputs */
/** @typedef {{}} Widget_Reply_EmptyInputs */
/** @typedef {{}} Widget_Reply_Notice_DismissInputs */
/** @typedef {{}} Widget_Reply_Notice_FailedInputs */
/** @typedef {{}} Widget_Reply_Notice_NewInputs */
/** @typedef {{}} Widget_Request_Already_Sent_TitleInputs */
/** @typedef {{}} Widget_Request_BackInputs */
/** @typedef {{}} Widget_Request_Load_Failed_TextInputs */
/** @typedef {{}} Widget_Request_Load_Failed_TitleInputs */
/** @typedef {{}} Widget_Request_Loading_TextInputs */
/** @typedef {{}} Widget_Request_Loading_TitleInputs */
/** @typedef {{ id: NonNullable<unknown> }} Widget_Request_MetaInputs */
/** @typedef {{ id: NonNullable<unknown>, time: NonNullable<unknown> }} Widget_Request_Meta_TimeInputs */
/** @typedef {{}} Widget_Request_Receipt_SentInputs */
/** @typedef {{}} Widget_Request_Send_Failed_TextInputs */
/** @typedef {{}} Widget_Request_Sending_TextInputs */
/** @typedef {{}} Widget_Request_Sending_TitleInputs */
/** @typedef {{}} Widget_Request_Try_AgainInputs */
/** @typedef {{}} Widget_Resize_Height_HelpInputs */
/** @typedef {{}} Widget_Resize_Height_LabelInputs */
/** @typedef {{}} Widget_Resize_HelpInputs */
/** @typedef {{}} Widget_Resize_LabelInputs */
/** @typedef {{}} Widget_Review_Contact_EmailInputs */
/** @typedef {{}} Widget_Review_EditInputs */
/** @typedef {{}} Widget_Review_Full_RequestInputs */
/** @typedef {{}} Widget_Review_InfoInputs */
/** @typedef {{}} Widget_Review_Not_NowInputs */
/** @typedef {{}} Widget_Review_Request_TypeInputs */
/** @typedef {{}} Widget_Review_SendInputs */
/** @typedef {{}} Widget_Review_TitleInputs */
/** @typedef {{}} Widget_Review_ToInputs */
/** @typedef {{}} Widget_Seen_ClearInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Seen_CurrentInputs */
/** @typedef {{}} Widget_Seen_LabelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Seen_MentionedInputs */
/** @typedef {{}} Widget_Select_PlaceholderInputs */
/** @typedef {{}} Widget_Sheet_CloseInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Shortlist_CompareInputs */
/** @typedef {{}} Widget_Shortlist_Compare_ToggleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Shortlist_HiddenInputs */
/** @typedef {{ value: NonNullable<unknown>, max: NonNullable<unknown> }} Widget_Shortlist_LevelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Shortlist_OpenInputs */
/** @typedef {{}} Widget_Size_HeadingInputs */
/** @typedef {{}} Widget_Size_RecommendedInputs */
/** @typedef {{}} Widget_Size_SourceInputs */
/** @typedef {{ size: NonNullable<unknown> }} Widget_Size_UsInputs */
/** @typedef {{}} Widget_Support_AvailableInputs */
/** @typedef {{}} Widget_Support_ConflictInputs */
/** @typedef {{}} Widget_Support_Copy_FailedInputs */
/** @typedef {{}} Widget_Support_Copy_SuccessInputs */
/** @typedef {{}} Widget_Support_ExpiredInputs */
/** @typedef {{}} Widget_Support_Expired_TitleInputs */
/** @typedef {{}} Widget_Support_FailedInputs */
/** @typedef {{}} Widget_Support_Field_ErrorInputs */
/** @typedef {{}} Widget_Support_InaccessibleInputs */
/** @typedef {{}} Widget_Support_LatestInputs */
/** @typedef {{}} Widget_Support_LoadingInputs */
/** @typedef {{ time: NonNullable<unknown> }} Widget_Support_Observed_AtInputs */
/** @typedef {{}} Widget_Support_Open_UnavailableInputs */
/** @typedef {{}} Widget_Support_Open_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Support_Pause_FailedInputs */
/** @typedef {{}} Widget_Support_PausedInputs */
/** @typedef {{ quantity: NonNullable<unknown> }} Widget_Support_QuantityInputs */
/** @typedef {{}} Widget_Support_Rate_LimitedInputs */
/** @typedef {{}} Widget_Support_Read_FailedInputs */
/** @typedef {{ id: NonNullable<unknown> }} Widget_Support_ReferenceInputs */
/** @typedef {{}} Widget_Support_ResumeInputs */
/** @typedef {{}} Widget_Support_Resume_FailedInputs */
/** @typedef {{}} Widget_Support_RetryInputs */
/** @typedef {{}} Widget_Support_SaveInputs */
/** @typedef {{}} Widget_Support_SavedInputs */
/** @typedef {{}} Widget_Support_ScopeInputs */
/** @typedef {{}} Widget_Support_Send_FailedInputs */
/** @typedef {{}} Widget_Support_Send_Not_ConfiguredInputs */
/** @typedef {{ facts: NonNullable<unknown>, time: NonNullable<unknown> }} Widget_Support_SnapshotInputs */
/** @typedef {{}} Widget_Support_Store_UnavailableInputs */
/** @typedef {{}} Widget_Support_UnavailableInputs */
/** @typedef {{}} Widget_Support_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Unavailable_Contact_PageInputs */
/** @typedef {{}} Widget_Unavailable_CopyInputs */
/** @typedef {{}} Widget_Unavailable_MessageInputs */
/** @typedef {{}} Widget_Unavailable_Other_WayInputs */
/** @typedef {{ number: NonNullable<unknown> }} Widget_Unavailable_PhoneInputs */
/** @typedef {{}} Widget_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Unsent_LabelInputs */
/** @typedef {{}} Widget_Unsent_ResumeInputs */
/** @typedef {{ type: NonNullable<unknown> }} Widget_Unsent_StatusInputs */
/** @typedef {{}} Widget_Unsent_TitleInputs */
/** @typedef {{ index: NonNullable<unknown>, length: NonNullable<unknown> }} Widget_Verification_Code_DigitInputs */
/** @typedef {{}} Widget_Verification_Code_LabelInputs */
/** @typedef {{}} Widget_Verification_Request_ActionInputs */
/** @typedef {{}} Widget_Verification_Request_DescriptionInputs */
/** @typedef {{}} Widget_Verification_Request_ExpiredInputs */
/** @typedef {{}} Widget_Verification_Request_PendingInputs */
/** @typedef {{}} Widget_Verification_Request_TitleInputs */
/** @typedef {{}} Widget_Verify_Code_ExpiredInputs */
/** @typedef {{}} Widget_Verify_Code_HintInputs */
/** @typedef {{ tries: NonNullable<unknown> }} Widget_Verify_Code_WrongInputs */
/** @typedef {{}} Widget_Verify_Code_Wrong_LastInputs */
/** @typedef {{}} Widget_Verify_ConfirmInputs */
/** @typedef {{}} Widget_Verify_Contact_StoreInputs */
/** @typedef {{}} Widget_Verify_Email_ActionInputs */
/** @typedef {{}} Widget_Verify_Email_InvalidInputs */
/** @typedef {{}} Widget_Verify_Email_LabelInputs */
/** @typedef {{}} Widget_Verify_Email_PlaceholderInputs */
/** @typedef {{}} Widget_Verify_FailedInputs */
/** @typedef {{}} Widget_Verify_IntroInputs */
/** @typedef {{}} Widget_Verify_LockedInputs */
/** @typedef {{}} Widget_Verify_Playground_ActionInputs */
/** @typedef {{}} Widget_Verify_ResendInputs */
/** @typedef {{}} Widget_Verify_Resend_InInputs */
/** @typedef {{}} Widget_Verify_SendInputs */
/** @typedef {{}} Widget_Verify_SuccessInputs */
/** @typedef {{}} Widget_Verify_TitleInputs */
/** @typedef {{}} Widget_Verify_UnavailableInputs */
/** @typedef {{}} Widget_Verify_UnknownInputs */
/** @typedef {{}} Widget_Voice_AnsweringInputs */
/** @typedef {{}} Widget_Voice_ClosedInputs */
/** @typedef {{}} Widget_Voice_ConnectingInputs */
/** @typedef {{}} Widget_Voice_DisableInputs */
/** @typedef {{}} Widget_Voice_EnableInputs */
/** @typedef {{}} Widget_Voice_EndedInputs */
/** @typedef {{}} Widget_Voice_ErrorInputs */
/** @typedef {{}} Widget_Voice_ListeningInputs */
/** @typedef {{}} Widget_Voice_OccupiedInputs */
/** @typedef {{}} Widget_Voice_ReplacedInputs */
/** @typedef {{}} Widget_Voice_RevokedInputs */
/** @typedef {{}} Widget_Voice_Turn_FailedInputs */
import * as __en from "./en.js"
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Widget_Action_CopiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_action_copied = /** @type {((inputs?: Widget_Action_CopiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Action_CopiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_action_copied(inputs)
});
/**
* | output |
* | --- |
* | "Change" |
*
* @param {Widget_Bag_ChangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_change = /** @type {((inputs?: Widget_Bag_ChangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_ChangeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_change(inputs)
});
/**
* | output |
* | --- |
* | "Checkout" |
*
* @param {Widget_Bag_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_checkout = /** @type {((inputs?: Widget_Bag_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_checkout(inputs)
});
/**
* | output |
* | --- |
* | "Close bag" |
*
* @param {Widget_Bag_CloseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_close = /** @type {((inputs?: Widget_Bag_CloseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_CloseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_close(inputs)
});
/**
* | output |
* | --- |
* | "One fewer {title}" |
*
* @param {Widget_Bag_DecreaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_decrease = /** @type {((inputs: Widget_Bag_DecreaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_DecreaseInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_decrease(inputs)
});
/**
* | output |
* | --- |
* | "One more {title}" |
*
* @param {Widget_Bag_IncreaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_increase = /** @type {((inputs: Widget_Bag_IncreaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_IncreaseInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_increase(inputs)
});
/**
* | output |
* | --- |
* | "Bag" |
*
* @param {Widget_Bag_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_label = /** @type {((inputs?: Widget_Bag_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_label(inputs)
});
/**
* | output |
* | --- |
* | "Open your bag, {count} items" |
*
* @param {Widget_Bag_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_open = /** @type {((inputs: Widget_Bag_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_OpenInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_open(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Widget_Bag_RemoveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_remove = /** @type {((inputs?: Widget_Bag_RemoveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_RemoveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_remove(inputs)
});
/**
* | output |
* | --- |
* | "Savings" |
*
* @param {Widget_Bag_SavingsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_savings = /** @type {((inputs?: Widget_Bag_SavingsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_SavingsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_savings(inputs)
});
/**
* | output |
* | --- |
* | "Shipping & taxes" |
*
* @param {Widget_Bag_ShippingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_shipping = /** @type {((inputs?: Widget_Bag_ShippingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_ShippingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_shipping(inputs)
});
/**
* | output |
* | --- |
* | "Calculated at checkout" |
*
* @param {Widget_Bag_Shipping_ValueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_shipping_value = /** @type {((inputs?: Widget_Bag_Shipping_ValueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_Shipping_ValueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_shipping_value(inputs)
});
/**
* | output |
* | --- |
* | "Subtotal" |
*
* @param {Widget_Bag_SubtotalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_subtotal = /** @type {((inputs?: Widget_Bag_SubtotalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_SubtotalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_subtotal(inputs)
});
/**
* | output |
* | --- |
* | "Synced with your store bag · Payment on Shopify" |
*
* @param {Widget_Bag_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_synced = /** @type {((inputs?: Widget_Bag_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_synced(inputs)
});
/**
* | output |
* | --- |
* | "Your bag" |
*
* @param {Widget_Bag_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_title = /** @type {((inputs?: Widget_Bag_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_title(inputs)
});
/**
* | output |
* | --- |
* | "Total" |
*
* @param {Widget_Bag_TotalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_bag_total = /** @type {((inputs?: Widget_Bag_TotalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Bag_TotalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_bag_total(inputs)
});
/**
* | output |
* | --- |
* | "Loading details…" |
*
* @param {Widget_Blocks_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_blocks_loading = /** @type {((inputs?: Widget_Blocks_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Blocks_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_blocks_loading(inputs)
});
/**
* | output |
* | --- |
* | "Details are currently unavailable." |
*
* @param {Widget_Blocks_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_blocks_pending = /** @type {((inputs?: Widget_Blocks_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Blocks_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_blocks_pending(inputs)
});
/**
* | output |
* | --- |
* | "Details could not be refreshed. Your form is kept; try again shortly." |
*
* @param {Widget_Blocks_Refresh_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_blocks_refresh_failed = /** @type {((inputs?: Widget_Blocks_Refresh_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Blocks_Refresh_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_blocks_refresh_failed(inputs)
});
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Widget_Board_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_board_open = /** @type {((inputs?: Widget_Board_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Board_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_board_open(inputs)
});
/**
* | output |
* | --- |
* | "On the board" |
*
* @param {Widget_Board_ShowingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_board_showing = /** @type {((inputs?: Widget_Board_ShowingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Board_ShowingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_board_showing(inputs)
});
/**
* | output |
* | --- |
* | "Couldn’t add to cart. Your choices are kept." |
*
* @param {Widget_Cart_Add_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_add_failed = /** @type {((inputs?: Widget_Cart_Add_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Add_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "Add to cart · {total}" |
*
* @param {Widget_Cart_Add_TotalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_add_total = /** @type {((inputs: Widget_Cart_Add_TotalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Add_TotalInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_add_total(inputs)
});
/**
* | output |
* | --- |
* | "Adding to your Shopify cart…" |
*
* @param {Widget_Cart_AddingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_adding = /** @type {((inputs?: Widget_Cart_AddingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_AddingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_adding(inputs)
});
/**
* | output |
* | --- |
* | "Adding…" |
*
* @param {Widget_Cart_Adding_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_adding_short = /** @type {((inputs?: Widget_Cart_Adding_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Adding_ShortInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_adding_short(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "The only one available is in your cart" |
* | "other" | "All {count} available are in your cart" |
*
* @param {Widget_Cart_All_In_CartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_all_in_cart = /** @type {((inputs: Widget_Cart_All_In_CartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_All_In_CartInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_all_in_cart(inputs)
});
/**
* | output |
* | --- |
* | "Only {count} available" |
*
* @param {Widget_Cart_AvailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_available = /** @type {((inputs: Widget_Cart_AvailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_AvailableInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_available(inputs)
});
/**
* | output |
* | --- |
* | "Couldn’t change it to {to}. Your cart still has {from}." |
*
* @param {Widget_Cart_Change_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_change_failed = /** @type {((inputs: Widget_Cart_Change_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Change_FailedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_change_failed(inputs)
});
/**
* | output |
* | --- |
* | "Couldn’t confirm the change. Try again." |
*
* @param {Widget_Cart_Change_UnconfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_change_unconfirmed = /** @type {((inputs?: Widget_Cart_Change_UnconfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Change_UnconfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_change_unconfirmed(inputs)
});
/**
* | output |
* | --- |
* | "Changes {from} to {to} in your Shopify cart" |
*
* @param {Widget_Cart_ChangesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_changes = /** @type {((inputs: Widget_Cart_ChangesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_ChangesInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_changes(inputs)
});
/**
* | output |
* | --- |
* | "Check again" |
*
* @param {Widget_Cart_Check_AgainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_check_again = /** @type {((inputs?: Widget_Cart_Check_AgainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Check_AgainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_check_again(inputs)
});
/**
* | output |
* | --- |
* | "Checking your cart…" |
*
* @param {Widget_Cart_CheckingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_checking = /** @type {((inputs?: Widget_Cart_CheckingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_CheckingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_checking(inputs)
});
/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Widget_Cart_Checking_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_checking_short = /** @type {((inputs?: Widget_Cart_Checking_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Checking_ShortInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_checking_short(inputs)
});
/**
* | output |
* | --- |
* | "Changed to {count}. Only {available} available." |
*
* @param {Widget_Cart_Clamp_AvailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_clamp_available = /** @type {((inputs: Widget_Cart_Clamp_AvailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Clamp_AvailableInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_clamp_available(inputs)
});
/**
* | output |
* | --- |
* | "Changed to {count}. {inCart} already in your cart." |
*
* @param {Widget_Cart_Clamp_In_CartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_clamp_in_cart = /** @type {((inputs: Widget_Cart_Clamp_In_CartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Clamp_In_CartInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_clamp_in_cart(inputs)
});
/**
* | output |
* | --- |
* | "Decrease quantity" |
*
* @param {Widget_Cart_DecreaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_decrease = /** @type {((inputs?: Widget_Cart_DecreaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_DecreaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_decrease(inputs)
});
/**
* | output |
* | --- |
* | "Edit quantity" |
*
* @param {Widget_Cart_Edit_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_edit_title = /** @type {((inputs?: Widget_Cart_Edit_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Edit_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_edit_title(inputs)
});
/**
* | output |
* | --- |
* | "Enter a quantity of 1 or more" |
*
* @param {Widget_Cart_Enter_QuantityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_enter_quantity = /** @type {((inputs?: Widget_Cart_Enter_QuantityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Enter_QuantityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_enter_quantity(inputs)
});
/**
* | output |
* | --- |
* | "{count} in cart" |
*
* @param {Widget_Cart_In_CartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_in_cart = /** @type {((inputs: Widget_Cart_In_CartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_In_CartInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_in_cart(inputs)
});
/**
* | output |
* | --- |
* | "Increase quantity" |
*
* @param {Widget_Cart_IncreaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_increase = /** @type {((inputs?: Widget_Cart_IncreaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_IncreaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_increase(inputs)
});
/**
* | output |
* | --- |
* | "The lowest quantity is 1." |
*
* @param {Widget_Cart_LowestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_lowest = /** @type {((inputs?: Widget_Cart_LowestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_LowestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_lowest(inputs)
});
/**
* | output |
* | --- |
* | "This item is no longer in your cart." |
*
* @param {Widget_Cart_MissingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_missing = /** @type {((inputs?: Widget_Cart_MissingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_MissingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_missing(inputs)
});
/**
* | output |
* | --- |
* | "New quantity" |
*
* @param {Widget_Cart_New_QuantityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_new_quantity = /** @type {((inputs?: Widget_Cart_New_QuantityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_New_QuantityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_new_quantity(inputs)
});
/**
* | output |
* | --- |
* | "In cart: {count}" |
*
* @param {Widget_Cart_Now_In_CartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_now_in_cart = /** @type {((inputs: Widget_Cart_Now_In_CartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Now_In_CartInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_now_in_cart(inputs)
});
/**
* | output |
* | --- |
* | "{name} · {value}" |
*
* @param {Widget_Cart_Option_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_option_heading = /** @type {((inputs: Widget_Cart_Option_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Option_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_option_heading(inputs)
});
/**
* | output |
* | --- |
* | "Quantity" |
*
* @param {Widget_Cart_QuantityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_quantity = /** @type {((inputs?: Widget_Cart_QuantityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_QuantityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_quantity(inputs)
});
/**
* | output |
* | --- |
* | "Couldn’t check your cart right now." |
*
* @param {Widget_Cart_Read_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_read_failed = /** @type {((inputs?: Widget_Cart_Read_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Read_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_read_failed(inputs)
});
/**
* | output |
* | --- |
* | "Added to cart" |
*
* @param {Widget_Cart_Receipt_AddedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_added = /** @type {((inputs?: Widget_Cart_Receipt_AddedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_AddedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_added(inputs)
});
/**
* | output |
* | --- |
* | "{added} added just now · {count} in your cart" |
*
* @param {Widget_Cart_Receipt_MergedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_merged = /** @type {((inputs: Widget_Cart_Receipt_MergedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_MergedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_merged(inputs)
});
/**
* | output |
* | --- |
* | "Added {added} of {requested}" |
*
* @param {Widget_Cart_Receipt_PartialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_partial = /** @type {((inputs: Widget_Cart_Receipt_PartialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_PartialInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_partial(inputs)
});
/**
* | output |
* | --- |
* | "Qty {count}" |
*
* @param {Widget_Cart_Receipt_QtyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_qty = /** @type {((inputs: Widget_Cart_Receipt_QtyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_QtyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_qty(inputs)
});
/**
* | output |
* | --- |
* | "You asked for {requested}. Only {count} available, so your cart has {count}." |
*
* @param {Widget_Cart_Receipt_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_short = /** @type {((inputs: Widget_Cart_Receipt_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_ShortInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_short(inputs)
});
/**
* | output |
* | --- |
* | "You asked for {requested} more. Only {count} available in total, so your cart has {count}." |
*
* @param {Widget_Cart_Receipt_Short_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_short_more = /** @type {((inputs: Widget_Cart_Receipt_Short_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_Short_MoreInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_short_more(inputs)
});
/**
* | output |
* | --- |
* | "Quantity updated" |
*
* @param {Widget_Cart_Receipt_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_receipt_updated = /** @type {((inputs?: Widget_Cart_Receipt_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Receipt_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_receipt_updated(inputs)
});
/**
* | output |
* | --- |
* | "Shopify didn’t accept this quantity." |
*
* @param {Widget_Cart_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_rejected = /** @type {((inputs?: Widget_Cart_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Widget_Cart_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_retry = /** @type {((inputs?: Widget_Cart_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_retry(inputs)
});
/**
* | output |
* | --- |
* | "Retry · set to {count}" |
*
* @param {Widget_Cart_Retry_SetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_retry_set = /** @type {((inputs: Widget_Cart_Retry_SetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Retry_SetInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_retry_set(inputs)
});
/**
* | output |
* | --- |
* | "Select {options}" |
*
* @param {Widget_Cart_SelectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_select = /** @type {((inputs: Widget_Cart_SelectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_SelectInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_select(inputs)
});
/**
* | output |
* | --- |
* | "{variant} · Qty {count}" |
*
* @param {Widget_Cart_SummaryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_summary = /** @type {((inputs: Widget_Cart_SummaryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_SummaryInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_summary(inputs)
});
/**
* | output |
* | --- |
* | "Qty {count}" |
*
* @param {Widget_Cart_Summary_DefaultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_summary_default = /** @type {((inputs: Widget_Cart_Summary_DefaultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Summary_DefaultInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_summary_default(inputs)
});
/**
* | output |
* | --- |
* | "Change the number to update your cart" |
*
* @param {Widget_Cart_UnchangedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_unchanged = /** @type {((inputs?: Widget_Cart_UnchangedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_UnchangedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_unchanged(inputs)
});
/**
* | output |
* | --- |
* | "Couldn’t confirm. Check your cart so nothing is added twice." |
*
* @param {Widget_Cart_UnconfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_unconfirmed = /** @type {((inputs?: Widget_Cart_UnconfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_UnconfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_unconfirmed(inputs)
});
/**
* | output |
* | --- |
* | "Update quantity" |
*
* @param {Widget_Cart_UpdateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_update = /** @type {((inputs?: Widget_Cart_UpdateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_UpdateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_update(inputs)
});
/**
* | output |
* | --- |
* | "Updating your Shopify cart…" |
*
* @param {Widget_Cart_UpdatingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_updating = /** @type {((inputs?: Widget_Cart_UpdatingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_UpdatingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_updating(inputs)
});
/**
* | output |
* | --- |
* | "Updating…" |
*
* @param {Widget_Cart_Updating_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_updating_short = /** @type {((inputs?: Widget_Cart_Updating_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Updating_ShortInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_updating_short(inputs)
});
/**
* | output |
* | --- |
* | "{value}, sold out" |
*
* @param {Widget_Cart_Value_Sold_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_value_sold_out = /** @type {((inputs: Widget_Cart_Value_Sold_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Value_Sold_OutInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_value_sold_out(inputs)
});
/**
* | output |
* | --- |
* | "{variant} is sold out" |
*
* @param {Widget_Cart_Variant_Sold_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_cart_variant_sold_out = /** @type {((inputs: Widget_Cart_Variant_Sold_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Cart_Variant_Sold_OutInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_cart_variant_sold_out(inputs)
});
/**
* | output |
* | --- |
* | "Add to bag" |
*
* @param {Widget_Compare_Add_RowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_compare_add_row = /** @type {((inputs?: Widget_Compare_Add_RowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Compare_Add_RowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_compare_add_row(inputs)
});
/**
* | output |
* | --- |
* | "You asked about this" |
*
* @param {Widget_Compare_AskedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_compare_asked = /** @type {((inputs?: Widget_Compare_AskedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Compare_AskedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_compare_asked(inputs)
});
/**
* | output |
* | --- |
* | "Comparison of {first} and {second}" |
*
* @param {Widget_Compare_CaptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_compare_caption = /** @type {((inputs: Widget_Compare_CaptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Compare_CaptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_compare_caption(inputs)
});
/**
* | output |
* | --- |
* | "Different" |
*
* @param {Widget_Compare_DiffersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_compare_differs = /** @type {((inputs?: Widget_Compare_DiffersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Compare_DiffersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_compare_differs(inputs)
});
/**
* | output |
* | --- |
* | "Detail" |
*
* @param {Widget_Compare_FieldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_compare_field = /** @type {((inputs?: Widget_Compare_FieldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Compare_FieldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_compare_field(inputs)
});
/**
* | output |
* | --- |
* | "Looking through the store…" |
*
* @param {Widget_Composer_BusyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_composer_busy = /** @type {((inputs?: Widget_Composer_BusyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Composer_BusyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_composer_busy(inputs)
});
/**
* | output |
* | --- |
* | "Ask a question…" |
*
* @param {Widget_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_composer_placeholder = /** @type {((inputs?: Widget_Composer_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Composer_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_composer_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Send" |
*
* @param {Widget_Composer_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_composer_send = /** @type {((inputs?: Widget_Composer_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Composer_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_composer_send(inputs)
});
/**
* | output |
* | --- |
* | "Tell the store what you need help with." |
*
* @param {Widget_Contact_Description_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_description_error = /** @type {((inputs?: Widget_Contact_Description_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Description_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_description_error(inputs)
});
/**
* | output |
* | --- |
* | "We filled this in from your chat. You can edit it." |
*
* @param {Widget_Contact_Description_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_description_hint = /** @type {((inputs?: Widget_Contact_Description_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Description_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_description_hint(inputs)
});
/**
* | output |
* | --- |
* | "What would you like help with?" |
*
* @param {Widget_Contact_Description_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_description_label = /** @type {((inputs?: Widget_Contact_Description_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Description_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_description_label(inputs)
});
/**
* | output |
* | --- |
* | "Tell the store what you need…" |
*
* @param {Widget_Contact_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_description_placeholder = /** @type {((inputs?: Widget_Contact_Description_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Description_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_description_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Widget_Contact_DismissInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_dismiss = /** @type {((inputs?: Widget_Contact_DismissInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_DismissInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_dismiss(inputs)
});
/**
* | output |
* | --- |
* | "Enter your email so the store can reply." |
*
* @param {Widget_Contact_Email_Error_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_error_empty = /** @type {((inputs?: Widget_Contact_Email_Error_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Error_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_error_empty(inputs)
});
/**
* | output |
* | --- |
* | "Enter a full email address, like name@example.com." |
*
* @param {Widget_Contact_Email_Error_FormatInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_error_format = /** @type {((inputs?: Widget_Contact_Email_Error_FormatInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Error_FormatInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_error_format(inputs)
});
/**
* | output |
* | --- |
* | "Use your own email. This is the store’s address, so replies wouldn’t reach you." |
*
* @param {Widget_Contact_Email_Error_OwnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_error_own = /** @type {((inputs?: Widget_Contact_Email_Error_OwnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Error_OwnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_error_own(inputs)
});
/**
* | output |
* | --- |
* | "From" |
*
* @param {Widget_Contact_Email_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_from = /** @type {((inputs?: Widget_Contact_Email_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_FromInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_from(inputs)
});
/**
* | output |
* | --- |
* | "From your store account" |
*
* @param {Widget_Contact_Email_Hint_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_hint_account = /** @type {((inputs?: Widget_Contact_Email_Hint_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Hint_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_hint_account(inputs)
});
/**
* | output |
* | --- |
* | "From your verified checkout email" |
*
* @param {Widget_Contact_Email_Hint_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_hint_checkout = /** @type {((inputs?: Widget_Contact_Email_Hint_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Hint_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_hint_checkout(inputs)
});
/**
* | output |
* | --- |
* | "Your contact email" |
*
* @param {Widget_Contact_Email_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_label = /** @type {((inputs?: Widget_Contact_Email_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_label(inputs)
});
/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Widget_Contact_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_placeholder = /** @type {((inputs?: Widget_Contact_Email_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Email preview" |
*
* @param {Widget_Contact_Email_Preview_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_preview_label = /** @type {((inputs?: Widget_Contact_Email_Preview_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Preview_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_preview_label(inputs)
});
/**
* | output |
* | --- |
* | "Reply-to" |
*
* @param {Widget_Contact_Email_Reply_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_reply_to = /** @type {((inputs?: Widget_Contact_Email_Reply_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_Reply_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_reply_to(inputs)
});
/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Widget_Contact_Email_SubjectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_subject = /** @type {((inputs?: Widget_Contact_Email_SubjectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_SubjectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_subject(inputs)
});
/**
* | output |
* | --- |
* | "To" |
*
* @param {Widget_Contact_Email_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_email_to = /** @type {((inputs?: Widget_Contact_Email_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Email_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_email_to(inputs)
});
/**
* | output |
* | --- |
* | "(optional)" |
*
* @param {Widget_Contact_OptionalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_optional = /** @type {((inputs?: Widget_Contact_OptionalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_OptionalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_optional(inputs)
});
/**
* | output |
* | --- |
* | "Not verified — the store will check it" |
*
* @param {Widget_Contact_Order_Hint_UnverifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_order_hint_unverified = /** @type {((inputs?: Widget_Contact_Order_Hint_UnverifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Order_Hint_UnverifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_order_hint_unverified(inputs)
});
/**
* | output |
* | --- |
* | "Verified with your checkout email" |
*
* @param {Widget_Contact_Order_Hint_VerifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_order_hint_verified = /** @type {((inputs?: Widget_Contact_Order_Hint_VerifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Order_Hint_VerifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_order_hint_verified(inputs)
});
/**
* | output |
* | --- |
* | "Order reference" |
*
* @param {Widget_Contact_Order_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_order_label = /** @type {((inputs?: Widget_Contact_Order_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Order_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_order_label(inputs)
});
/**
* | output |
* | --- |
* | "#1234" |
*
* @param {Widget_Contact_Order_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_order_placeholder = /** @type {((inputs?: Widget_Contact_Order_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Order_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_order_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Widget_Contact_Order_VerifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_order_verified = /** @type {((inputs?: Widget_Contact_Order_VerifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Order_VerifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_order_verified(inputs)
});
/**
* | output |
* | --- |
* | "View product" |
*
* @param {Widget_Contact_Product_ViewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_product_view = /** @type {((inputs?: Widget_Contact_Product_ViewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Product_ViewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_product_view(inputs)
});
/**
* | output |
* | --- |
* | "Price and stock as of {time}" |
*
* @param {Widget_Contact_Products_As_OfInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_products_as_of = /** @type {((inputs: Widget_Contact_Products_As_OfInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Products_As_OfInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_products_as_of(inputs)
});
/**
* | output |
* | --- |
* | "Related products" |
*
* @param {Widget_Contact_Products_LegendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_products_legend = /** @type {((inputs?: Widget_Contact_Products_LegendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Products_LegendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_products_legend(inputs)
});
/**
* | output |
* | --- |
* | "To · Store" |
*
* @param {Widget_Contact_Recipient_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_recipient_label = /** @type {((inputs?: Widget_Contact_Recipient_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Recipient_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_recipient_label(inputs)
});
/**
* | output |
* | --- |
* | "The store will reply to your request by email." |
*
* @param {Widget_Contact_Reply_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_reply_note = /** @type {((inputs?: Widget_Contact_Reply_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Reply_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_reply_note(inputs)
});
/**
* | output |
* | --- |
* | "Request type" |
*
* @param {Widget_Contact_Request_TypeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_request_type = /** @type {((inputs?: Widget_Contact_Request_TypeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Request_TypeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_request_type(inputs)
});
/**
* | output |
* | --- |
* | "Review request" |
*
* @param {Widget_Contact_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_review = /** @type {((inputs?: Widget_Contact_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_review(inputs)
});
/**
* | output |
* | --- |
* | "Send request" |
*
* @param {Widget_Contact_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_send = /** @type {((inputs?: Widget_Contact_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_send(inputs)
});
/**
* | output |
* | --- |
* | "How can the store help?" |
*
* @param {Widget_Contact_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_title = /** @type {((inputs?: Widget_Contact_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_title(inputs)
});
/**
* | output |
* | --- |
* | "Delivery issues" |
*
* @param {Widget_Contact_Type_Delivery_IssuesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_delivery_issues = /** @type {((inputs?: Widget_Contact_Type_Delivery_IssuesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_Delivery_IssuesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_delivery_issues(inputs)
});
/**
* | output |
* | --- |
* | "Order cancellation" |
*
* @param {Widget_Contact_Type_Order_CancellationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_order_cancellation = /** @type {((inputs?: Widget_Contact_Type_Order_CancellationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_Order_CancellationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_order_cancellation(inputs)
});
/**
* | output |
* | --- |
* | "Order changes" |
*
* @param {Widget_Contact_Type_Order_ChangesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_order_changes = /** @type {((inputs?: Widget_Contact_Type_Order_ChangesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_Order_ChangesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_order_changes(inputs)
});
/**
* | output |
* | --- |
* | "Order status and tracking" |
*
* @param {Widget_Contact_Type_Order_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_order_status = /** @type {((inputs?: Widget_Contact_Type_Order_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_Order_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_order_status(inputs)
});
/**
* | output |
* | --- |
* | "Other requests and contact support" |
*
* @param {Widget_Contact_Type_OtherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_other = /** @type {((inputs?: Widget_Contact_Type_OtherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_OtherInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_other(inputs)
});
/**
* | output |
* | --- |
* | "Product issues and warranty" |
*
* @param {Widget_Contact_Type_Product_IssuesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_product_issues = /** @type {((inputs?: Widget_Contact_Type_Product_IssuesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_Product_IssuesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_product_issues(inputs)
});
/**
* | output |
* | --- |
* | "Returns, exchanges and refunds" |
*
* @param {Widget_Contact_Type_ReturnsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_returns = /** @type {((inputs?: Widget_Contact_Type_ReturnsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_ReturnsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_returns(inputs)
});
/**
* | output |
* | --- |
* | "Product subscriptions" |
*
* @param {Widget_Contact_Type_SubscriptionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_contact_type_subscriptions = /** @type {((inputs?: Widget_Contact_Type_SubscriptionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Contact_Type_SubscriptionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_contact_type_subscriptions(inputs)
});
/**
* | output |
* | --- |
* | "Back to latest" |
*
* @param {Widget_Conversation_LatestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_conversation_latest = /** @type {((inputs?: Widget_Conversation_LatestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Conversation_LatestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_conversation_latest(inputs)
});
/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Widget_Conversation_MessagesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_conversation_messages = /** @type {((inputs?: Widget_Conversation_MessagesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Conversation_MessagesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_conversation_messages(inputs)
});
/**
* | output |
* | --- |
* | "Resize chat" |
*
* @param {Widget_Drawer_ResizeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_drawer_resize = /** @type {((inputs?: Widget_Drawer_ResizeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Drawer_ResizeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_drawer_resize(inputs)
});
/**
* | output |
* | --- |
* | "Accepted for sending" |
*
* @param {Widget_Email_Result_Accepted_FactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_accepted_fact = /** @type {((inputs?: Widget_Email_Result_Accepted_FactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Accepted_FactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_accepted_fact(inputs)
});
/**
* | output |
* | --- |
* | "Check original email" |
*
* @param {Widget_Email_Result_CheckInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_check = /** @type {((inputs?: Widget_Email_Result_CheckInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_CheckInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_check(inputs)
});
/**
* | output |
* | --- |
* | "Edit request" |
*
* @param {Widget_Email_Result_EditInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_edit = /** @type {((inputs?: Widget_Email_Result_EditInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_EditInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_edit(inputs)
});
/**
* | output |
* | --- |
* | "Your email" |
*
* @param {Widget_Email_Result_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_email = /** @type {((inputs?: Widget_Email_Result_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_email(inputs)
});
/**
* | output |
* | --- |
* | "Request {id}" |
*
* @param {Widget_Email_Result_GroupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_group = /** @type {((inputs: Widget_Email_Result_GroupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_GroupInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_group(inputs)
});
/**
* | output |
* | --- |
* | "Next" |
*
* @param {Widget_Email_Result_NextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_next = /** @type {((inputs?: Widget_Email_Result_NextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_NextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_next(inputs)
});
/**
* | output |
* | --- |
* | "The store’s inbox didn’t accept this email. Sending was accepted, but delivery failed. Contact the store through its published contact channels." |
*
* @param {Widget_Email_Result_Next_BouncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_next_bounced = /** @type {((inputs?: Widget_Email_Result_Next_BouncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Next_BouncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_next_bounced(inputs)
});
/**
* | output |
* | --- |
* | "Your details are saved. Try sending again." |
*
* @param {Widget_Email_Result_Next_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_next_failed = /** @type {((inputs?: Widget_Email_Result_Next_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Next_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_next_failed(inputs)
});
/**
* | output |
* | --- |
* | "The store will reply to {email} by email." |
*
* @param {Widget_Email_Result_Next_ReplyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_next_reply = /** @type {((inputs: Widget_Email_Result_Next_ReplyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Next_ReplyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_next_reply(inputs)
});
/**
* | output |
* | --- |
* | "We’ll show the result here in a moment." |
*
* @param {Widget_Email_Result_Next_SendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_next_sending = /** @type {((inputs?: Widget_Email_Result_Next_SendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Next_SendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_next_sending(inputs)
});
/**
* | output |
* | --- |
* | "We’re checking the original email. Delivery is not confirmed. Check its status without sending it again." |
*
* @param {Widget_Email_Result_Next_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_next_unknown = /** @type {((inputs?: Widget_Email_Result_Next_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Next_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_next_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Request" |
*
* @param {Widget_Email_Result_RequestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_request = /** @type {((inputs?: Widget_Email_Result_RequestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_RequestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_request(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Widget_Email_Result_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_retry = /** @type {((inputs?: Widget_Email_Result_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_retry(inputs)
});
/**
* | output |
* | --- |
* | "Sending request" |
*
* @param {Widget_Email_Result_Sending_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_sending_action = /** @type {((inputs?: Widget_Email_Result_Sending_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Sending_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_sending_action(inputs)
});
/**
* | output |
* | --- |
* | "Start a new request" |
*
* @param {Widget_Email_Result_Start_NewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_start_new = /** @type {((inputs?: Widget_Email_Result_Start_NewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Start_NewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_start_new(inputs)
});
/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {Widget_Email_Result_SubmittedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_submitted = /** @type {((inputs?: Widget_Email_Result_SubmittedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_SubmittedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_submitted(inputs)
});
/**
* | output |
* | --- |
* | "Delivery is not yet confirmed" |
*
* @param {Widget_Email_Result_Subtitle_AcceptedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_subtitle_accepted = /** @type {((inputs?: Widget_Email_Result_Subtitle_AcceptedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Subtitle_AcceptedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_subtitle_accepted(inputs)
});
/**
* | output |
* | --- |
* | "Request sent" |
*
* @param {Widget_Email_Result_Title_AcceptedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_title_accepted = /** @type {((inputs?: Widget_Email_Result_Title_AcceptedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Title_AcceptedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_title_accepted(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t deliver your request to the store" |
*
* @param {Widget_Email_Result_Title_BouncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_title_bounced = /** @type {((inputs?: Widget_Email_Result_Title_BouncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Title_BouncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_title_bounced(inputs)
});
/**
* | output |
* | --- |
* | "Email delivered" |
*
* @param {Widget_Email_Result_Title_DeliveredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_title_delivered = /** @type {((inputs?: Widget_Email_Result_Title_DeliveredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Title_DeliveredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_title_delivered(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t send your request" |
*
* @param {Widget_Email_Result_Title_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_title_failed = /** @type {((inputs?: Widget_Email_Result_Title_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Title_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_title_failed(inputs)
});
/**
* | output |
* | --- |
* | "Sending request" |
*
* @param {Widget_Email_Result_Title_SendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_title_sending = /** @type {((inputs?: Widget_Email_Result_Title_SendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Title_SendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_title_sending(inputs)
});
/**
* | output |
* | --- |
* | "Checking email status" |
*
* @param {Widget_Email_Result_Title_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_title_unknown = /** @type {((inputs?: Widget_Email_Result_Title_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_Title_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_title_unknown(inputs)
});
/**
* | output |
* | --- |
* | "To" |
*
* @param {Widget_Email_Result_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_to = /** @type {((inputs?: Widget_Email_Result_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_to(inputs)
});
/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Widget_Email_Result_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_email_result_updated = /** @type {((inputs?: Widget_Email_Result_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Email_Result_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_email_result_updated(inputs)
});
/**
* | output |
* | --- |
* | "How can I help today?" |
*
* @param {Widget_Empty_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_empty_title = /** @type {((inputs?: Widget_Empty_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Empty_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_empty_title(inputs)
});
/**
* | output |
* | --- |
* | "The previous answer could not be restored. Your message is kept below; send it again to retry." |
*
* @param {Widget_Error_Answer_LostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_error_answer_lost = /** @type {((inputs?: Widget_Error_Answer_LostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Error_Answer_LostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_error_answer_lost(inputs)
});
/**
* | output |
* | --- |
* | "Chat is unavailable." |
*
* @param {Widget_Error_Chat_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_error_chat_unavailable = /** @type {((inputs?: Widget_Error_Chat_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Error_Chat_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_error_chat_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Chat is unavailable. Your message is kept below; send it again to retry." |
*
* @param {Widget_Error_No_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_error_no_answer = /** @type {((inputs?: Widget_Error_No_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Error_No_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_error_no_answer(inputs)
});
/**
* | output |
* | --- |
* | "This Playground session expired and could not be refreshed. Reload the page, then open the app from Shopify again if it keeps happening." |
*
* @param {Widget_Error_Playground_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_error_playground_expired = /** @type {((inputs?: Widget_Error_Playground_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Error_Playground_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_error_playground_expired(inputs)
});
/**
* | output |
* | --- |
* | "Sign-in isn't available right now. You can keep chatting as a guest." |
*
* @param {Widget_Error_Signin_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_error_signin_unavailable = /** @type {((inputs?: Widget_Error_Signin_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Error_Signin_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_error_signin_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Sold out" |
*
* @param {Widget_Evidence_Sold_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_evidence_sold_out = /** @type {((inputs?: Widget_Evidence_Sold_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Evidence_Sold_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_evidence_sold_out(inputs)
});
/**
* | output |
* | --- |
* | "View on the store page" |
*
* @param {Widget_Evidence_Store_PageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_evidence_store_page = /** @type {((inputs?: Widget_Evidence_Store_PageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Evidence_Store_PageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_evidence_store_page(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Widget_Feedback_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_cancel = /** @type {((inputs?: Widget_Feedback_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_CancelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Widget_Feedback_DefaultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_default = /** @type {((inputs?: Widget_Feedback_DefaultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_DefaultInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_default(inputs)
});
/**
* | output |
* | --- |
* | "Describe the issue and a better approach. Leave out personal information." |
*
* @param {Widget_Feedback_Details_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_details_placeholder = /** @type {((inputs?: Widget_Feedback_Details_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_Details_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_details_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Your feedback will help GoNovus team to improve AI responses" |
*
* @param {Widget_Feedback_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_help = /** @type {((inputs?: Widget_Feedback_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_help(inputs)
});
/**
* | output |
* | --- |
* | "Message feedback" |
*
* @param {Widget_Feedback_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_label = /** @type {((inputs?: Widget_Feedback_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_label(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load feedback reasons." |
*
* @param {Widget_Feedback_Load_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_load_failed = /** @type {((inputs?: Widget_Feedback_Load_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_Load_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Loading reasons…" |
*
* @param {Widget_Feedback_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_loading = /** @type {((inputs?: Widget_Feedback_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_loading(inputs)
});
/**
* | output |
* | --- |
* | "Network error. Check your connection and try again." |
*
* @param {Widget_Feedback_Network_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_network_failed = /** @type {((inputs?: Widget_Feedback_Network_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_Network_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_network_failed(inputs)
});
/**
* | output |
* | --- |
* | "Send feedback" |
*
* @param {Widget_Feedback_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_send = /** @type {((inputs?: Widget_Feedback_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_send(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't send this feedback. Try again." |
*
* @param {Widget_Feedback_Send_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_send_failed = /** @type {((inputs?: Widget_Feedback_Send_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_Send_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_send_failed(inputs)
});
/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {Widget_Feedback_SubmittedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_submitted = /** @type {((inputs?: Widget_Feedback_SubmittedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_SubmittedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_submitted(inputs)
});
/**
* | output |
* | --- |
* | "Submitted by {memberName}" |
*
* @param {Widget_Feedback_Submitted_ByInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_submitted_by = /** @type {((inputs: Widget_Feedback_Submitted_ByInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_Submitted_ByInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_submitted_by(inputs)
});
/**
* | output |
* | --- |
* | "What went wrong?" |
*
* @param {Widget_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_feedback_title = /** @type {((inputs?: Widget_Feedback_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Feedback_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_feedback_title(inputs)
});
/**
* | output |
* | --- |
* | "Powered by GoNovus" |
*
* @param {Widget_Footer_Powered_ByInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_footer_powered_by = /** @type {((inputs?: Widget_Footer_Powered_ByInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Footer_Powered_ByInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_footer_powered_by(inputs)
});
/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Widget_Form_DismissInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_form_dismiss = /** @type {((inputs?: Widget_Form_DismissInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Form_DismissInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_form_dismiss(inputs)
});
/**
* | output |
* | --- |
* | "Flipping through the catalog…" |
*
* @param {Widget_Generating_CatalogInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_catalog = /** @type {((inputs?: Widget_Generating_CatalogInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_CatalogInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_catalog(inputs)
});
/**
* | output |
* | --- |
* | "Sniffing out deals…" |
*
* @param {Widget_Generating_DealsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_deals = /** @type {((inputs?: Widget_Generating_DealsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_DealsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_deals(inputs)
});
/**
* | output |
* | --- |
* | "Double-checking the details…" |
*
* @param {Widget_Generating_DetailsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_details = /** @type {((inputs?: Widget_Generating_DetailsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_DetailsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_details(inputs)
});
/**
* | output |
* | --- |
* | "Rummaging through the racks…" |
*
* @param {Widget_Generating_RacksInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_racks = /** @type {((inputs?: Widget_Generating_RacksInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_RacksInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_racks(inputs)
});
/**
* | output |
* | --- |
* | "Browsing the shelves…" |
*
* @param {Widget_Generating_ShelvesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_shelves = /** @type {((inputs?: Widget_Generating_ShelvesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_ShelvesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_shelves(inputs)
});
/**
* | output |
* | --- |
* | "Still on it…" |
*
* @param {Widget_Generating_StillInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_still = /** @type {((inputs?: Widget_Generating_StillInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_StillInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_still(inputs)
});
/**
* | output |
* | --- |
* | "Peeking in the stockroom…" |
*
* @param {Widget_Generating_StockroomInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_generating_stockroom = /** @type {((inputs?: Widget_Generating_StockroomInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Generating_StockroomInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_generating_stockroom(inputs)
});
/**
* | output |
* | --- |
* | "Clear conversation" |
*
* @param {Widget_Header_ClearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_clear = /** @type {((inputs?: Widget_Header_ClearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_ClearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_clear(inputs)
});
/**
* | output |
* | --- |
* | "Close chat" |
*
* @param {Widget_Header_CloseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_close = /** @type {((inputs?: Widget_Header_CloseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_CloseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_close(inputs)
});
/**
* | output |
* | --- |
* | "Enter full screen" |
*
* @param {Widget_Header_Enter_FullscreenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_enter_fullscreen = /** @type {((inputs?: Widget_Header_Enter_FullscreenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_Enter_FullscreenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_enter_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Open your space" |
*
* @param {Widget_Header_Enter_SpaceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_enter_space = /** @type {((inputs?: Widget_Header_Enter_SpaceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_Enter_SpaceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_enter_space(inputs)
});
/**
* | output |
* | --- |
* | "Exit full screen" |
*
* @param {Widget_Header_Exit_FullscreenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_exit_fullscreen = /** @type {((inputs?: Widget_Header_Exit_FullscreenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_Exit_FullscreenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_exit_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Back to chat window" |
*
* @param {Widget_Header_Exit_SpaceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_exit_space = /** @type {((inputs?: Widget_Header_Exit_SpaceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_Exit_SpaceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_exit_space(inputs)
});
/**
* | output |
* | --- |
* | "Minimize" |
*
* @param {Widget_Header_MinimizeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_minimize = /** @type {((inputs?: Widget_Header_MinimizeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_MinimizeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_minimize(inputs)
});
/**
* | output |
* | --- |
* | "Replies instantly" |
*
* @param {Widget_Header_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_status = /** @type {((inputs?: Widget_Header_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_status(inputs)
});
/**
* | output |
* | --- |
* | "Shopping assistant" |
*
* @param {Widget_Header_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_header_title = /** @type {((inputs?: Widget_Header_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Header_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_header_title(inputs)
});
/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Widget_Launcher_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_launcher_label = /** @type {((inputs?: Widget_Launcher_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Launcher_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_launcher_label(inputs)
});
/**
* | output |
* | --- |
* | "Opening chat…" |
*
* @param {Widget_Loading_ChatInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_loading_chat = /** @type {((inputs?: Widget_Loading_ChatInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Loading_ChatInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_loading_chat(inputs)
});
/**
* | output |
* | --- |
* | "In your bag · {variant}" |
*
* @param {Widget_Look_In_BagInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_look_in_bag = /** @type {((inputs: Widget_Look_In_BagInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Look_In_BagInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_look_in_bag(inputs)
});
/**
* | output |
* | --- |
* | "{label} · {index} of {total}" |
*
* @param {Widget_Look_PositionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_look_position = /** @type {((inputs: Widget_Look_PositionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Look_PositionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_look_position(inputs)
});
/**
* | output |
* | --- |
* | "Selected · {variant}" |
*
* @param {Widget_Look_SelectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_look_selected = /** @type {((inputs: Widget_Look_SelectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Look_SelectedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_look_selected(inputs)
});
/**
* | output |
* | --- |
* | "Swap" |
*
* @param {Widget_Look_SwapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_look_swap = /** @type {((inputs?: Widget_Look_SwapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Look_SwapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_look_swap(inputs)
});
/**
* | output |
* | --- |
* | "Swap the {role}" |
*
* @param {Widget_Look_Swap_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_look_swap_label = /** @type {((inputs: Widget_Look_Swap_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Look_Swap_LabelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_look_swap_label(inputs)
});
/**
* | output |
* | --- |
* | "Copy message" |
*
* @param {Widget_Message_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_copy = /** @type {((inputs?: Widget_Message_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_copy(inputs)
});
/**
* | output |
* | --- |
* | "Not helpful" |
*
* @param {Widget_Message_DislikeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_dislike = /** @type {((inputs?: Widget_Message_DislikeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_DislikeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_dislike(inputs)
});
/**
* | output |
* | --- |
* | "We’ll do better" |
*
* @param {Widget_Message_Feedback_SorryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_feedback_sorry = /** @type {((inputs?: Widget_Message_Feedback_SorryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_Feedback_SorryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_feedback_sorry(inputs)
});
/**
* | output |
* | --- |
* | "Thanks for the feedback" |
*
* @param {Widget_Message_Feedback_ThanksInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_feedback_thanks = /** @type {((inputs?: Widget_Message_Feedback_ThanksInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_Feedback_ThanksInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_feedback_thanks(inputs)
});
/**
* | output |
* | --- |
* | "Image from the store" |
*
* @param {Widget_Message_ImageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_image = /** @type {((inputs?: Widget_Message_ImageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_ImageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_image(inputs)
});
/**
* | output |
* | --- |
* | "Close image" |
*
* @param {Widget_Message_Image_CloseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_image_close = /** @type {((inputs?: Widget_Message_Image_CloseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_Image_CloseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_image_close(inputs)
});
/**
* | output |
* | --- |
* | "Enlarge image" |
*
* @param {Widget_Message_Image_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_image_open = /** @type {((inputs?: Widget_Message_Image_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_Image_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_image_open(inputs)
});
/**
* | output |
* | --- |
* | "This image could not be loaded." |
*
* @param {Widget_Message_Image_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_image_unavailable = /** @type {((inputs?: Widget_Message_Image_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_Image_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_image_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Helpful" |
*
* @param {Widget_Message_LikeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_like = /** @type {((inputs?: Widget_Message_LikeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_LikeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_like(inputs)
});
/**
* | output |
* | --- |
* | "Replying" |
*
* @param {Widget_Message_ReplyingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_replying = /** @type {((inputs?: Widget_Message_ReplyingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_ReplyingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_replying(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Widget_Message_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_retry = /** @type {((inputs?: Widget_Message_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_retry(inputs)
});
/**
* | output |
* | --- |
* | "Not delivered" |
*
* @param {Widget_Message_UndeliveredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_undelivered = /** @type {((inputs?: Widget_Message_UndeliveredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_UndeliveredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_undelivered(inputs)
});
/**
* | output |
* | --- |
* | "This part of the message cannot be displayed." |
*
* @param {Widget_Message_UnsupportedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_message_unsupported = /** @type {((inputs?: Widget_Message_UnsupportedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Message_UnsupportedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_message_unsupported(inputs)
});
/**
* | output |
* | --- |
* | "Now viewing · {title}" |
*
* @param {Widget_Notice_Now_ViewingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_notice_now_viewing = /** @type {((inputs: Widget_Notice_Now_ViewingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Notice_Now_ViewingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_notice_now_viewing(inputs)
});
/**
* | output |
* | --- |
* | "Cancellation, returns and refunds" |
*
* @param {Widget_Order_AdjustmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_adjustments = /** @type {((inputs?: Widget_Order_AdjustmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_AdjustmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_adjustments(inputs)
});
/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Widget_Order_Canceled_ItemsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_canceled_items = /** @type {((inputs?: Widget_Order_Canceled_ItemsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Canceled_ItemsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_canceled_items(inputs)
});
/**
* | output |
* | --- |
* | "Order canceled" |
*
* @param {Widget_Order_CancellationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_cancellation = /** @type {((inputs?: Widget_Order_CancellationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_CancellationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_cancellation(inputs)
});
/**
* | output |
* | --- |
* | "Carrier not provided" |
*
* @param {Widget_Order_Carrier_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_carrier_unknown = /** @type {((inputs?: Widget_Order_Carrier_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Carrier_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_carrier_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Check my order" |
*
* @param {Widget_Order_Check_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_check_action = /** @type {((inputs?: Widget_Order_Check_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Check_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_check_action(inputs)
});
/**
* | output |
* | --- |
* | "Contact store" |
*
* @param {Widget_Order_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_contact = /** @type {((inputs?: Widget_Order_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_contact(inputs)
});
/**
* | output |
* | --- |
* | "Order details" |
*
* @param {Widget_Order_Details_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_details_label = /** @type {((inputs?: Widget_Order_Details_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Details_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_details_label(inputs)
});
/**
* | output |
* | --- |
* | "No readable orders found" |
*
* @param {Widget_Order_Empty_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_empty_title = /** @type {((inputs?: Widget_Order_Empty_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Empty_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_empty_title(inputs)
});
/**
* | output |
* | --- |
* | "These order details are unavailable." |
*
* @param {Widget_Order_Error_InaccessibleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_error_inaccessible = /** @type {((inputs?: Widget_Order_Error_InaccessibleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Error_InaccessibleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_error_inaccessible(inputs)
});
/**
* | output |
* | --- |
* | "Order details are currently unavailable." |
*
* @param {Widget_Order_Error_OfflineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_error_offline = /** @type {((inputs?: Widget_Order_Error_OfflineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Error_OfflineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_error_offline(inputs)
});
/**
* | output |
* | --- |
* | "Order details are currently unavailable." |
*
* @param {Widget_Order_Error_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_error_rate_limited = /** @type {((inputs?: Widget_Order_Error_Rate_LimitedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Error_Rate_LimitedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_error_rate_limited(inputs)
});
/**
* | output |
* | --- |
* | "Order details are currently unavailable." |
*
* @param {Widget_Order_Error_UpstreamInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_error_upstream = /** @type {((inputs?: Widget_Order_Error_UpstreamInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Error_UpstreamInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_error_upstream(inputs)
});
/**
* | output |
* | --- |
* | "Verify your identity to view order details." |
*
* @param {Widget_Order_Error_VerificationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_error_verification = /** @type {((inputs?: Widget_Order_Error_VerificationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Error_VerificationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_error_verification(inputs)
});
/**
* | output |
* | --- |
* | "Source estimate: {time}" |
*
* @param {Widget_Order_Eta_SourceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_eta_source = /** @type {((inputs: Widget_Order_Eta_SourceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Eta_SourceInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_eta_source(inputs)
});
/**
* | output |
* | --- |
* | "Delivery estimate not provided" |
*
* @param {Widget_Order_Eta_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_eta_unknown = /** @type {((inputs?: Widget_Order_Eta_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Eta_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_eta_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Checking your order…" |
*
* @param {Widget_Order_Event_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_event_waiting = /** @type {((inputs?: Widget_Order_Event_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Event_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_event_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Order" |
*
* @param {Widget_Order_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_eyebrow = /** @type {((inputs?: Widget_Order_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_eyebrow(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t load your orders" |
*
* @param {Widget_Order_Failed_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_failed_title = /** @type {((inputs?: Widget_Order_Failed_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Failed_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_failed_title(inputs)
});
/**
* | output |
* | --- |
* | "Fulfilled items" |
*
* @param {Widget_Order_Fulfilled_ItemsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_fulfilled_items = /** @type {((inputs?: Widget_Order_Fulfilled_ItemsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Fulfilled_ItemsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_fulfilled_items(inputs)
});
/**
* | output |
* | --- |
* | "Order details hidden" |
*
* @param {Widget_Order_Hidden_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_hidden_title = /** @type {((inputs?: Widget_Order_Hidden_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Hidden_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_hidden_title(inputs)
});
/**
* | output |
* | --- |
* | "Qty {count}" |
*
* @param {Widget_Order_Item_QuantityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_item_quantity = /** @type {((inputs: Widget_Order_Item_QuantityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Item_QuantityInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_item_quantity(inputs)
});
/**
* | output |
* | --- |
* | "Label created — carrier pickup not confirmed" |
*
* @param {Widget_Order_Label_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_label_created = /** @type {((inputs?: Widget_Order_Label_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Label_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_label_created(inputs)
});
/**
* | output |
* | --- |
* | "Loading your order…" |
*
* @param {Widget_Order_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_loading = /** @type {((inputs?: Widget_Order_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_loading(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} more fulfillment record not shown" |
* | "other" | "{count} more fulfillment records not shown" |
*
* @param {Widget_Order_More_FulfillmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_more_fulfillments = /** @type {((inputs: Widget_Order_More_FulfillmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_More_FulfillmentsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_more_fulfillments(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} more refund record not shown" |
* | "other" | "{count} more refund records not shown" |
*
* @param {Widget_Order_More_RefundsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_more_refunds = /** @type {((inputs: Widget_Order_More_RefundsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_More_RefundsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_more_refunds(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} more return not shown" |
* | "other" | "{count} more returns not shown" |
*
* @param {Widget_Order_More_ReturnsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_more_returns = /** @type {((inputs: Widget_Order_More_ReturnsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_More_ReturnsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_more_returns(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} more tracking number not shown" |
* | "other" | "{count} more tracking numbers not shown" |
*
* @param {Widget_Order_More_TrackingsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_more_trackings = /** @type {((inputs: Widget_Order_More_TrackingsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_More_TrackingsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_more_trackings(inputs)
});
/**
* | output |
* | --- |
* | "No shipping required" |
*
* @param {Widget_Order_No_ShippingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_no_shipping = /** @type {((inputs?: Widget_Order_No_ShippingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_No_ShippingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_no_shipping(inputs)
});
/**
* | output |
* | --- |
* | "I haven’t received this" |
*
* @param {Widget_Order_Not_ReceivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_not_received = /** @type {((inputs?: Widget_Order_Not_ReceivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Not_ReceivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_not_received(inputs)
});
/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Widget_Order_PaymentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment = /** @type {((inputs?: Widget_Order_PaymentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_PaymentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment(inputs)
});
/**
* | output |
* | --- |
* | "Authorized" |
*
* @param {Widget_Order_Payment_AuthorizedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_authorized = /** @type {((inputs?: Widget_Order_Payment_AuthorizedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_AuthorizedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_authorized(inputs)
});
/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Widget_Order_Payment_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_paid = /** @type {((inputs?: Widget_Order_Payment_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_paid(inputs)
});
/**
* | output |
* | --- |
* | "Partially paid" |
*
* @param {Widget_Order_Payment_Partially_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_partially_paid = /** @type {((inputs?: Widget_Order_Payment_Partially_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_Partially_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_partially_paid(inputs)
});
/**
* | output |
* | --- |
* | "Partially refunded" |
*
* @param {Widget_Order_Payment_Partially_RefundedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_partially_refunded = /** @type {((inputs?: Widget_Order_Payment_Partially_RefundedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_Partially_RefundedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_partially_refunded(inputs)
});
/**
* | output |
* | --- |
* | "Payment pending" |
*
* @param {Widget_Order_Payment_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_pending = /** @type {((inputs?: Widget_Order_Payment_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_pending(inputs)
});
/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Widget_Order_Payment_RefundedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_refunded = /** @type {((inputs?: Widget_Order_Payment_RefundedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_RefundedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_refunded(inputs)
});
/**
* | output |
* | --- |
* | "Voided" |
*
* @param {Widget_Order_Payment_VoidedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_payment_voided = /** @type {((inputs?: Widget_Order_Payment_VoidedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Payment_VoidedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_payment_voided(inputs)
});
/**
* | output |
* | --- |
* | "Awaiting fulfillment" |
*
* @param {Widget_Order_Pending_ItemsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_pending_items = /** @type {((inputs?: Widget_Order_Pending_ItemsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Pending_ItemsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_pending_items(inputs)
});
/**
* | output |
* | --- |
* | "Order progress" |
*
* @param {Widget_Order_Progress_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_progress_label = /** @type {((inputs?: Widget_Order_Progress_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Progress_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_progress_label(inputs)
});
/**
* | output |
* | --- |
* | "Refund record" |
*
* @param {Widget_Order_Refund_RecordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_refund_record = /** @type {((inputs?: Widget_Order_Refund_RecordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Refund_RecordInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_refund_record(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Widget_Order_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_retry = /** @type {((inputs?: Widget_Order_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_retry(inputs)
});
/**
* | output |
* | --- |
* | "Return {name}" |
*
* @param {Widget_Order_Return_RecordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_return_record = /** @type {((inputs: Widget_Order_Return_RecordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Return_RecordInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_return_record(inputs)
});
/**
* | output |
* | --- |
* | "Ship to" |
*
* @param {Widget_Order_Ship_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_ship_to = /** @type {((inputs?: Widget_Order_Ship_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Ship_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_ship_to(inputs)
});
/**
* | output |
* | --- |
* | "Shipped items" |
*
* @param {Widget_Order_Shipped_ItemsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_shipped_items = /** @type {((inputs?: Widget_Order_Shipped_ItemsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Shipped_ItemsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_shipped_items(inputs)
});
/**
* | output |
* | --- |
* | "Items" |
*
* @param {Widget_Order_Shipping_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_shipping_unknown = /** @type {((inputs?: Widget_Order_Shipping_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Shipping_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_shipping_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Status" |
*
* @param {Widget_Order_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_status = /** @type {((inputs?: Widget_Order_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_status(inputs)
});
/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Widget_Order_Status_CanceledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_status_canceled = /** @type {((inputs?: Widget_Order_Status_CanceledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Status_CanceledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_status_canceled(inputs)
});
/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Widget_Order_Status_DeliveredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_status_delivered = /** @type {((inputs?: Widget_Order_Status_DeliveredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Status_DeliveredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_status_delivered(inputs)
});
/**
* | output |
* | --- |
* | "Partially shipped" |
*
* @param {Widget_Order_Status_Partially_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_status_partially_shipped = /** @type {((inputs?: Widget_Order_Status_Partially_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Status_Partially_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_status_partially_shipped(inputs)
});
/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Widget_Order_Status_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_status_shipped = /** @type {((inputs?: Widget_Order_Status_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Status_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_status_shipped(inputs)
});
/**
* | output |
* | --- |
* | "Unfulfilled" |
*
* @param {Widget_Order_Status_UnfulfilledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_status_unfulfilled = /** @type {((inputs?: Widget_Order_Status_UnfulfilledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Status_UnfulfilledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_status_unfulfilled(inputs)
});
/**
* | output |
* | --- |
* | "Arrives" |
*
* @param {Widget_Order_Step_ArrivesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_step_arrives = /** @type {((inputs?: Widget_Order_Step_ArrivesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Step_ArrivesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_step_arrives(inputs)
});
/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Widget_Order_Step_DeliveredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_step_delivered = /** @type {((inputs?: Widget_Order_Step_DeliveredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Step_DeliveredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_step_delivered(inputs)
});
/**
* | output |
* | --- |
* | "Placed" |
*
* @param {Widget_Order_Step_PlacedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_step_placed = /** @type {((inputs?: Widget_Order_Step_PlacedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Step_PlacedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_step_placed(inputs)
});
/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Widget_Order_Step_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_step_shipped = /** @type {((inputs?: Widget_Order_Step_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Step_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_step_shipped(inputs)
});
/**
* | output |
* | --- |
* | "Total" |
*
* @param {Widget_Order_TotalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_total = /** @type {((inputs?: Widget_Order_TotalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_TotalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_total(inputs)
});
/**
* | output |
* | --- |
* | "Track shipment" |
*
* @param {Widget_Order_TrackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_track = /** @type {((inputs?: Widget_Order_TrackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_TrackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_track(inputs)
});
/**
* | output |
* | --- |
* | "Order details unavailable" |
*
* @param {Widget_Order_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_unavailable_title = /** @type {((inputs?: Widget_Order_Unavailable_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Unavailable_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_unavailable_title(inputs)
});
/**
* | output |
* | --- |
* | "Not provided" |
*
* @param {Widget_Order_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_unknown = /** @type {((inputs?: Widget_Order_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Verification complete." |
*
* @param {Widget_Order_VerifiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_verified = /** @type {((inputs?: Widget_Order_VerifiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_VerifiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_verified(inputs)
});
/**
* | output |
* | --- |
* | "Showing orders for {email}." |
*
* @param {Widget_Order_Verified_DetailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_verified_detail = /** @type {((inputs: Widget_Order_Verified_DetailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_Verified_DetailInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_verified_detail(inputs)
});
/**
* | output |
* | --- |
* | "View order" |
*
* @param {Widget_Order_ViewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_order_view = /** @type {((inputs?: Widget_Order_ViewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Order_ViewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_order_view(inputs)
});
/**
* | output |
* | --- |
* | "To find more orders, ask with your order number." |
*
* @param {Widget_Orders_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_limit_reached = /** @type {((inputs?: Widget_Orders_Limit_ReachedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Limit_ReachedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_limit_reached(inputs)
});
/**
* | output |
* | --- |
* | "Orders, newest first" |
*
* @param {Widget_Orders_List_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_list_label = /** @type {((inputs?: Widget_Orders_List_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_List_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_list_label(inputs)
});
/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Widget_Orders_Load_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_load_more = /** @type {((inputs?: Widget_Orders_Load_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Load_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_load_more(inputs)
});
/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Widget_Orders_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_loading = /** @type {((inputs?: Widget_Orders_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_loading(inputs)
});
/**
* | output |
* | --- |
* | "Loading your orders…" |
*
* @param {Widget_Orders_Loading_FirstInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_loading_first = /** @type {((inputs?: Widget_Orders_Loading_FirstInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Loading_FirstInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_loading_first(inputs)
});
/**
* | output |
* | --- |
* | "Loading more orders…" |
*
* @param {Widget_Orders_Loading_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_loading_status = /** @type {((inputs?: Widget_Orders_Loading_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Loading_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_loading_status(inputs)
});
/**
* | output |
* | --- |
* | "+ {count} more" |
*
* @param {Widget_Orders_More_ItemsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_more_items = /** @type {((inputs: Widget_Orders_More_ItemsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_More_ItemsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_more_items(inputs)
});
/**
* | output |
* | --- |
* | "Newest first" |
*
* @param {Widget_Orders_Newest_FirstInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_newest_first = /** @type {((inputs?: Widget_Orders_Newest_FirstInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Newest_FirstInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_newest_first(inputs)
});
/**
* | output |
* | --- |
* | "Order {number}" |
*
* @param {Widget_Orders_Order_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_order_number = /** @type {((inputs: Widget_Orders_Order_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Order_NumberInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_order_number(inputs)
});
/**
* | output |
* | --- |
* | "No more orders are readable from this account. You can contact the store for help." |
*
* @param {Widget_Orders_Readable_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_readable_empty = /** @type {((inputs?: Widget_Orders_Readable_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Readable_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_readable_empty(inputs)
});
/**
* | output |
* | --- |
* | "Show {count} more" |
*
* @param {Widget_Orders_Show_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_show_more = /** @type {((inputs: Widget_Orders_Show_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_Show_MoreInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_show_more(inputs)
});
/**
* | output |
* | --- |
* | "Your orders" |
*
* @param {Widget_Orders_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_orders_title = /** @type {((inputs?: Widget_Orders_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Orders_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_orders_title(inputs)
});
/**
* | output |
* | --- |
* | "Open chat" |
*
* @param {Widget_Peek_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_peek_open = /** @type {((inputs?: Widget_Peek_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Peek_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_peek_open(inputs)
});
/**
* | output |
* | --- |
* | "Use this element?" |
*
* @param {Widget_Picker_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_confirm = /** @type {((inputs?: Widget_Picker_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_confirm(inputs)
});
/**
* | output |
* | --- |
* | "This pick link was already used or expired. Go back to the app admin to check the rule." |
*
* @param {Widget_Picker_ConsumedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_consumed = /** @type {((inputs?: Widget_Picker_ConsumedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_ConsumedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_consumed(inputs)
});
/**
* | output |
* | --- |
* | "Exit element picker" |
*
* @param {Widget_Picker_ExitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_exit = /** @type {((inputs?: Widget_Picker_ExitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_ExitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_exit(inputs)
});
/**
* | output |
* | --- |
* | "Could not save. Try again." |
*
* @param {Widget_Picker_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_failed = /** @type {((inputs?: Widget_Picker_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_failed(inputs)
});
/**
* | output |
* | --- |
* | "For rule: {prompt}" |
*
* @param {Widget_Picker_For_RuleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_for_rule = /** @type {((inputs: Widget_Picker_For_RuleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_For_RuleInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_for_rule(inputs)
});
/**
* | output |
* | --- |
* | "Hover to highlight an element, press Enter to select it. Esc exits." |
*
* @param {Widget_Picker_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_hint = /** @type {((inputs?: Widget_Picker_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_hint(inputs)
});
/**
* | output |
* | --- |
* | "This pick link is invalid or expired. Open it again from the app admin." |
*
* @param {Widget_Picker_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_invalid = /** @type {((inputs?: Widget_Picker_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Element picker" |
*
* @param {Widget_Picker_RegionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_region = /** @type {((inputs?: Widget_Picker_RegionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_RegionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_region(inputs)
});
/**
* | output |
* | --- |
* | "Pick again" |
*
* @param {Widget_Picker_ReselectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_reselect = /** @type {((inputs?: Widget_Picker_ReselectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_ReselectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_reselect(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Widget_Picker_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_retry = /** @type {((inputs?: Widget_Picker_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_retry(inputs)
});
/**
* | output |
* | --- |
* | "This rule was removed or changed. Go back to the app admin." |
*
* @param {Widget_Picker_Rule_GoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_rule_gone = /** @type {((inputs?: Widget_Picker_Rule_GoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_Rule_GoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_rule_gone(inputs)
});
/**
* | output |
* | --- |
* | "Save & return" |
*
* @param {Widget_Picker_SaveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_save = /** @type {((inputs?: Widget_Picker_SaveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_SaveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_save(inputs)
});
/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Widget_Picker_SavingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_saving = /** @type {((inputs?: Widget_Picker_SavingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_SavingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_saving(inputs)
});
/**
* | output |
* | --- |
* | "That element can’t be used. Pick a different one." |
*
* @param {Widget_Picker_Selector_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_picker_selector_rejected = /** @type {((inputs?: Widget_Picker_Selector_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Picker_Selector_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_picker_selector_rejected(inputs)
});
/**
* | output |
* | --- |
* | "Test as this customer" |
*
* @param {Widget_Playground_Customer_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_playground_customer_action = /** @type {((inputs?: Widget_Playground_Customer_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Playground_Customer_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_playground_customer_action(inputs)
});
/**
* | output |
* | --- |
* | "Playground has no store sign-in. Enter the email of a customer in your store to test as that customer." |
*
* @param {Widget_Playground_Customer_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_playground_customer_description = /** @type {((inputs?: Widget_Playground_Customer_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Playground_Customer_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_playground_customer_description(inputs)
});
/**
* | output |
* | --- |
* | "Customer email" |
*
* @param {Widget_Playground_Customer_Email_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_playground_customer_email_label = /** @type {((inputs?: Widget_Playground_Customer_Email_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Playground_Customer_Email_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_playground_customer_email_label(inputs)
});
/**
* | output |
* | --- |
* | "No customer in your store uses this email." |
*
* @param {Widget_Playground_Customer_Not_FoundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_playground_customer_not_found = /** @type {((inputs?: Widget_Playground_Customer_Not_FoundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Playground_Customer_Not_FoundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_playground_customer_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Need a hand finding your size?" |
*
* @param {Widget_Preview_ProactiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_preview_proactive = /** @type {((inputs?: Widget_Preview_ProactiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Preview_ProactiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_preview_proactive(inputs)
});
/**
* | output |
* | --- |
* | "Classic Linen Shirt" |
*
* @param {Widget_Preview_Product_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_preview_product_title = /** @type {((inputs?: Widget_Preview_Product_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Preview_Product_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_preview_product_title(inputs)
});
/**
* | output |
* | --- |
* | "Dismiss suggestion" |
*
* @param {Widget_Proactive_DismissInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_proactive_dismiss = /** @type {((inputs?: Widget_Proactive_DismissInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Proactive_DismissInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_proactive_dismiss(inputs)
});
/**
* | output |
* | --- |
* | "Add to cart" |
*
* @param {Widget_Product_AddInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_product_add = /** @type {((inputs?: Widget_Product_AddInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Product_AddInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_product_add(inputs)
});
/**
* | output |
* | --- |
* | "View cart" |
*
* @param {Widget_Product_CartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_product_cart = /** @type {((inputs?: Widget_Product_CartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Product_CartInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_product_cart(inputs)
});
/**
* | output |
* | --- |
* | "Unable to check availability. Please open the product page." |
*
* @param {Widget_Product_Load_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_product_load_failed = /** @type {((inputs?: Widget_Product_Load_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Product_Load_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_product_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "{price} · Opening…" |
*
* @param {Widget_Product_OpeningInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_product_opening = /** @type {((inputs: Widget_Product_OpeningInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Product_OpeningInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_product_opening(inputs)
});
/**
* | output |
* | --- |
* | "Sold out" |
*
* @param {Widget_Product_Sold_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_product_sold_out = /** @type {((inputs?: Widget_Product_Sold_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Product_Sold_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_product_sold_out(inputs)
});
/**
* | output |
* | --- |
* | "Subscription only" |
*
* @param {Widget_Product_SubscriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_product_subscription = /** @type {((inputs?: Widget_Product_SubscriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Product_SubscriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_product_subscription(inputs)
});
/**
* | output |
* | --- |
* | "Handed off" |
*
* @param {Widget_Replay_Handed_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_replay_handed_off = /** @type {((inputs?: Widget_Replay_Handed_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Replay_Handed_OffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_replay_handed_off(inputs)
});
/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Widget_Reply_Card_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_currency = /** @type {((inputs?: Widget_Reply_Card_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_currency(inputs)
});
/**
* | output |
* | --- |
* | "Details" |
*
* @param {Widget_Reply_Card_DetailsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_details = /** @type {((inputs?: Widget_Reply_Card_DetailsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_DetailsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_details(inputs)
});
/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Widget_Reply_Card_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_expired = /** @type {((inputs?: Widget_Reply_Card_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_expired(inputs)
});
/**
* | output |
* | --- |
* | "Attachment" |
*
* @param {Widget_Reply_Card_GenericInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_generic = /** @type {((inputs?: Widget_Reply_Card_GenericInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_GenericInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_generic(inputs)
});
/**
* | output |
* | --- |
* | "Some order details are unavailable." |
*
* @param {Widget_Reply_Card_Missing_FieldsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_missing_fields = /** @type {((inputs?: Widget_Reply_Card_Missing_FieldsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_Missing_FieldsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_missing_fields(inputs)
});
/**
* | output |
* | --- |
* | "Notice" |
*
* @param {Widget_Reply_Card_NoticeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_notice = /** @type {((inputs?: Widget_Reply_Card_NoticeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_NoticeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_notice(inputs)
});
/**
* | output |
* | --- |
* | "Order" |
*
* @param {Widget_Reply_Card_Order_DetailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_order_detail = /** @type {((inputs?: Widget_Reply_Card_Order_DetailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_Order_DetailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_order_detail(inputs)
});
/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Widget_Reply_Card_Order_ListInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_order_list = /** @type {((inputs?: Widget_Reply_Card_Order_ListInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_Order_ListInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_order_list(inputs)
});
/**
* | output |
* | --- |
* | "Quick action" |
*
* @param {Widget_Reply_Card_Quick_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_quick_action = /** @type {((inputs?: Widget_Reply_Card_Quick_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_Quick_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_quick_action(inputs)
});
/**
* | output |
* | --- |
* | "Revoked" |
*
* @param {Widget_Reply_Card_RevokedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_revoked = /** @type {((inputs?: Widget_Reply_Card_RevokedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_RevokedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_revoked(inputs)
});
/**
* | output |
* | --- |
* | "Support request" |
*
* @param {Widget_Reply_Card_Support_RequestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_support_request = /** @type {((inputs?: Widget_Reply_Card_Support_RequestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_Support_RequestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_support_request(inputs)
});
/**
* | output |
* | --- |
* | "Verification" |
*
* @param {Widget_Reply_Card_VerificationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_card_verification = /** @type {((inputs?: Widget_Reply_Card_VerificationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Card_VerificationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_card_verification(inputs)
});
/**
* | output |
* | --- |
* | "I couldn’t answer that. Please contact the store for help." |
*
* @param {Widget_Reply_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_empty = /** @type {((inputs?: Widget_Reply_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_empty(inputs)
});
/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Widget_Reply_Notice_DismissInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_notice_dismiss = /** @type {((inputs?: Widget_Reply_Notice_DismissInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Notice_DismissInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_notice_dismiss(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong. Open the chat to try again." |
*
* @param {Widget_Reply_Notice_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_notice_failed = /** @type {((inputs?: Widget_Reply_Notice_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Notice_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_notice_failed(inputs)
});
/**
* | output |
* | --- |
* | "You have a new reply." |
*
* @param {Widget_Reply_Notice_NewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_reply_notice_new = /** @type {((inputs?: Widget_Reply_Notice_NewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Reply_Notice_NewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_reply_notice_new(inputs)
});
/**
* | output |
* | --- |
* | "You already sent this request" |
*
* @param {Widget_Request_Already_Sent_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_already_sent_title = /** @type {((inputs?: Widget_Request_Already_Sent_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Already_Sent_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_already_sent_title(inputs)
});
/**
* | output |
* | --- |
* | "Back to conversation" |
*
* @param {Widget_Request_BackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_back = /** @type {((inputs?: Widget_Request_BackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_BackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_back(inputs)
});
/**
* | output |
* | --- |
* | "Your draft is still here. Please try again." |
*
* @param {Widget_Request_Load_Failed_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_load_failed_text = /** @type {((inputs?: Widget_Request_Load_Failed_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Load_Failed_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_load_failed_text(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t load this request" |
*
* @param {Widget_Request_Load_Failed_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_load_failed_title = /** @type {((inputs?: Widget_Request_Load_Failed_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Load_Failed_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_load_failed_title(inputs)
});
/**
* | output |
* | --- |
* | "Your conversation stays right here." |
*
* @param {Widget_Request_Loading_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_loading_text = /** @type {((inputs?: Widget_Request_Loading_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Loading_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_loading_text(inputs)
});
/**
* | output |
* | --- |
* | "Loading your request" |
*
* @param {Widget_Request_Loading_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_loading_title = /** @type {((inputs?: Widget_Request_Loading_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Loading_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_loading_title(inputs)
});
/**
* | output |
* | --- |
* | "Request {id}" |
*
* @param {Widget_Request_MetaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_meta = /** @type {((inputs: Widget_Request_MetaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_MetaInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_meta(inputs)
});
/**
* | output |
* | --- |
* | "Request {id} · {time}" |
*
* @param {Widget_Request_Meta_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_meta_time = /** @type {((inputs: Widget_Request_Meta_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Meta_TimeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_meta_time(inputs)
});
/**
* | output |
* | --- |
* | "Your request has been sent" |
*
* @param {Widget_Request_Receipt_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_receipt_sent = /** @type {((inputs?: Widget_Request_Receipt_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Receipt_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_receipt_sent(inputs)
});
/**
* | output |
* | --- |
* | "Nothing was sent. Your details are kept." |
*
* @param {Widget_Request_Send_Failed_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_send_failed_text = /** @type {((inputs?: Widget_Request_Send_Failed_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Send_Failed_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_send_failed_text(inputs)
});
/**
* | output |
* | --- |
* | "Please keep this open for a moment." |
*
* @param {Widget_Request_Sending_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_sending_text = /** @type {((inputs?: Widget_Request_Sending_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Sending_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_sending_text(inputs)
});
/**
* | output |
* | --- |
* | "Sending your request" |
*
* @param {Widget_Request_Sending_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_sending_title = /** @type {((inputs?: Widget_Request_Sending_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Sending_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_sending_title(inputs)
});
/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Widget_Request_Try_AgainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_request_try_again = /** @type {((inputs?: Widget_Request_Try_AgainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Request_Try_AgainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_request_try_again(inputs)
});
/**
* | output |
* | --- |
* | "Drag up or down to change the height, or use the up and down arrow keys. Hold Shift for larger steps. Press Home to reset the height." |
*
* @param {Widget_Resize_Height_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_resize_height_help = /** @type {((inputs?: Widget_Resize_Height_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Resize_Height_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_resize_height_help(inputs)
});
/**
* | output |
* | --- |
* | "Resize conversation height" |
*
* @param {Widget_Resize_Height_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_resize_height_label = /** @type {((inputs?: Widget_Resize_Height_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Resize_Height_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_resize_height_label(inputs)
});
/**
* | output |
* | --- |
* | "Drag to resize, or use arrow keys. Hold Shift for larger steps. Press Home to reset the size." |
*
* @param {Widget_Resize_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_resize_help = /** @type {((inputs?: Widget_Resize_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Resize_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_resize_help(inputs)
});
/**
* | output |
* | --- |
* | "Resize conversation" |
*
* @param {Widget_Resize_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_resize_label = /** @type {((inputs?: Widget_Resize_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Resize_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_resize_label(inputs)
});
/**
* | output |
* | --- |
* | "Contact email" |
*
* @param {Widget_Review_Contact_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_contact_email = /** @type {((inputs?: Widget_Review_Contact_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_Contact_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_contact_email(inputs)
});
/**
* | output |
* | --- |
* | "Edit details" |
*
* @param {Widget_Review_EditInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_edit = /** @type {((inputs?: Widget_Review_EditInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_EditInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_edit(inputs)
});
/**
* | output |
* | --- |
* | "Full request" |
*
* @param {Widget_Review_Full_RequestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_full_request = /** @type {((inputs?: Widget_Review_Full_RequestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_Full_RequestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_full_request(inputs)
});
/**
* | output |
* | --- |
* | "We’ll email the store with your request and contact email. The store can reply to you directly." |
*
* @param {Widget_Review_InfoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_info = /** @type {((inputs?: Widget_Review_InfoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_InfoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_info(inputs)
});
/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Widget_Review_Not_NowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_not_now = /** @type {((inputs?: Widget_Review_Not_NowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_Not_NowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_not_now(inputs)
});
/**
* | output |
* | --- |
* | "Request type" |
*
* @param {Widget_Review_Request_TypeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_request_type = /** @type {((inputs?: Widget_Review_Request_TypeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_Request_TypeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_request_type(inputs)
});
/**
* | output |
* | --- |
* | "Send request" |
*
* @param {Widget_Review_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_send = /** @type {((inputs?: Widget_Review_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_send(inputs)
});
/**
* | output |
* | --- |
* | "Review your request" |
*
* @param {Widget_Review_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_title = /** @type {((inputs?: Widget_Review_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_title(inputs)
});
/**
* | output |
* | --- |
* | "To" |
*
* @param {Widget_Review_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_review_to = /** @type {((inputs?: Widget_Review_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Review_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_review_to(inputs)
});
/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Widget_Seen_ClearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_seen_clear = /** @type {((inputs?: Widget_Seen_ClearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Seen_ClearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_seen_clear(inputs)
});
/**
* | output |
* | --- |
* | "{title}, on the board now" |
*
* @param {Widget_Seen_CurrentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_seen_current = /** @type {((inputs: Widget_Seen_CurrentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Seen_CurrentInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_seen_current(inputs)
});
/**
* | output |
* | --- |
* | "Seen" |
*
* @param {Widget_Seen_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_seen_label = /** @type {((inputs?: Widget_Seen_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Seen_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_seen_label(inputs)
});
/**
* | output |
* | --- |
* | "{title}, the one you mentioned" |
*
* @param {Widget_Seen_MentionedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_seen_mentioned = /** @type {((inputs: Widget_Seen_MentionedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Seen_MentionedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_seen_mentioned(inputs)
});
/**
* | output |
* | --- |
* | "Select an option" |
*
* @param {Widget_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_select_placeholder = /** @type {((inputs?: Widget_Select_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Select_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_select_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Widget_Sheet_CloseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_sheet_close = /** @type {((inputs?: Widget_Sheet_CloseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Sheet_CloseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_sheet_close(inputs)
});
/**
* | output |
* | --- |
* | "Compare {count} selected" |
*
* @param {Widget_Shortlist_CompareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_shortlist_compare = /** @type {((inputs: Widget_Shortlist_CompareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Shortlist_CompareInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_shortlist_compare(inputs)
});
/**
* | output |
* | --- |
* | "Compare" |
*
* @param {Widget_Shortlist_Compare_ToggleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_shortlist_compare_toggle = /** @type {((inputs?: Widget_Shortlist_Compare_ToggleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Shortlist_Compare_ToggleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_shortlist_compare_toggle(inputs)
});
/**
* | output |
* | --- |
* | "Show {count} more" |
*
* @param {Widget_Shortlist_HiddenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_shortlist_hidden = /** @type {((inputs: Widget_Shortlist_HiddenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Shortlist_HiddenInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_shortlist_hidden(inputs)
});
/**
* | output |
* | --- |
* | "{value} of {max}" |
*
* @param {Widget_Shortlist_LevelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_shortlist_level = /** @type {((inputs: Widget_Shortlist_LevelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Shortlist_LevelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_shortlist_level(inputs)
});
/**
* | output |
* | --- |
* | "Open {title}" |
*
* @param {Widget_Shortlist_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_shortlist_open = /** @type {((inputs: Widget_Shortlist_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Shortlist_OpenInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_shortlist_open(inputs)
});
/**
* | output |
* | --- |
* | "Recommended size" |
*
* @param {Widget_Size_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_size_heading = /** @type {((inputs?: Widget_Size_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Size_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_size_heading(inputs)
});
/**
* | output |
* | --- |
* | "Recommended size" |
*
* @param {Widget_Size_RecommendedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_size_recommended = /** @type {((inputs?: Widget_Size_RecommendedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Size_RecommendedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_size_recommended(inputs)
});
/**
* | output |
* | --- |
* | "Source:" |
*
* @param {Widget_Size_SourceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_size_source = /** @type {((inputs?: Widget_Size_SourceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Size_SourceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_size_source(inputs)
});
/**
* | output |
* | --- |
* | "US {size}" |
*
* @param {Widget_Size_UsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_size_us = /** @type {((inputs: Widget_Size_UsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Size_UsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_size_us(inputs)
});
/**
* | output |
* | --- |
* | "In stock" |
*
* @param {Widget_Support_AvailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_available = /** @type {((inputs?: Widget_Support_AvailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_AvailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_available(inputs)
});
/**
* | output |
* | --- |
* | "This request has a newer version. Your input is kept. Review the latest version before saving." |
*
* @param {Widget_Support_ConflictInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_conflict = /** @type {((inputs?: Widget_Support_ConflictInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_ConflictInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_conflict(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy the summary. Please select and copy the text below." |
*
* @param {Widget_Support_Copy_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_copy_failed = /** @type {((inputs?: Widget_Support_Copy_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Copy_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Summary copied." |
*
* @param {Widget_Support_Copy_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_copy_success = /** @type {((inputs?: Widget_Support_Copy_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Copy_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_copy_success(inputs)
});
/**
* | output |
* | --- |
* | "This request has expired. Ask for help again in the conversation." |
*
* @param {Widget_Support_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_expired = /** @type {((inputs?: Widget_Support_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_expired(inputs)
});
/**
* | output |
* | --- |
* | "Request expired" |
*
* @param {Widget_Support_Expired_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_expired_title = /** @type {((inputs?: Widget_Support_Expired_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Expired_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_expired_title(inputs)
});
/**
* | output |
* | --- |
* | "Could not save this request. Your input is kept. Please try again." |
*
* @param {Widget_Support_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_failed = /** @type {((inputs?: Widget_Support_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_failed(inputs)
});
/**
* | output |
* | --- |
* | "Check this field. It may be missing, invalid, or too long." |
*
* @param {Widget_Support_Field_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_field_error = /** @type {((inputs?: Widget_Support_Field_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Field_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_field_error(inputs)
});
/**
* | output |
* | --- |
* | "This request is no longer accessible. You can ask for help again in the conversation." |
*
* @param {Widget_Support_InaccessibleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_inaccessible = /** @type {((inputs?: Widget_Support_InaccessibleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_InaccessibleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_inaccessible(inputs)
});
/**
* | output |
* | --- |
* | "Use latest version" |
*
* @param {Widget_Support_LatestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_latest = /** @type {((inputs?: Widget_Support_LatestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_LatestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_latest(inputs)
});
/**
* | output |
* | --- |
* | "Loading request…" |
*
* @param {Widget_Support_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_loading = /** @type {((inputs?: Widget_Support_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_loading(inputs)
});
/**
* | output |
* | --- |
* | "Snapshot recorded at {time}" |
*
* @param {Widget_Support_Observed_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_observed_at = /** @type {((inputs: Widget_Support_Observed_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Observed_AtInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_observed_at(inputs)
});
/**
* | output |
* | --- |
* | "The store contact form is temporarily unavailable. Please try the store’s other contact options." |
*
* @param {Widget_Support_Open_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_open_unavailable = /** @type {((inputs?: Widget_Support_Open_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Open_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_open_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Contact form unavailable" |
*
* @param {Widget_Support_Open_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_open_unavailable_title = /** @type {((inputs?: Widget_Support_Open_Unavailable_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Open_Unavailable_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_open_unavailable_title(inputs)
});
/**
* | output |
* | --- |
* | "Could not pause this request. Your input is kept. Please try again." |
*
* @param {Widget_Support_Pause_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_pause_failed = /** @type {((inputs?: Widget_Support_Pause_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Pause_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_pause_failed(inputs)
});
/**
* | output |
* | --- |
* | "Draft saved. Resume whenever you are ready." |
*
* @param {Widget_Support_PausedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_paused = /** @type {((inputs?: Widget_Support_PausedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_PausedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_paused(inputs)
});
/**
* | output |
* | --- |
* | "Qty {quantity}" |
*
* @param {Widget_Support_QuantityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_quantity = /** @type {((inputs: Widget_Support_QuantityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_QuantityInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_quantity(inputs)
});
/**
* | output |
* | --- |
* | "Too many requests. Please wait before trying again." |
*
* @param {Widget_Support_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_rate_limited = /** @type {((inputs?: Widget_Support_Rate_LimitedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Rate_LimitedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_rate_limited(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t load this request. Please try again." |
*
* @param {Widget_Support_Read_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_read_failed = /** @type {((inputs?: Widget_Support_Read_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Read_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_read_failed(inputs)
});
/**
* | output |
* | --- |
* | "Request {id}" |
*
* @param {Widget_Support_ReferenceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_reference = /** @type {((inputs: Widget_Support_ReferenceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_ReferenceInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_reference(inputs)
});
/**
* | output |
* | --- |
* | "Resume request" |
*
* @param {Widget_Support_ResumeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_resume = /** @type {((inputs?: Widget_Support_ResumeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_ResumeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_resume(inputs)
});
/**
* | output |
* | --- |
* | "Could not resume this request. Your draft is kept. Please try again." |
*
* @param {Widget_Support_Resume_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_resume_failed = /** @type {((inputs?: Widget_Support_Resume_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Resume_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_resume_failed(inputs)
});
/**
* | output |
* | --- |
* | "Reload request" |
*
* @param {Widget_Support_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_retry = /** @type {((inputs?: Widget_Support_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_retry(inputs)
});
/**
* | output |
* | --- |
* | "Save draft" |
*
* @param {Widget_Support_SaveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_save = /** @type {((inputs?: Widget_Support_SaveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_SaveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_save(inputs)
});
/**
* | output |
* | --- |
* | "Draft saved. No email has been sent." |
*
* @param {Widget_Support_SavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_saved = /** @type {((inputs?: Widget_Support_SavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_SavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_saved(inputs)
});
/**
* | output |
* | --- |
* | "Request scope" |
*
* @param {Widget_Support_ScopeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_scope = /** @type {((inputs?: Widget_Support_ScopeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_ScopeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_scope(inputs)
});
/**
* | output |
* | --- |
* | "Could not send this request. Check its status before trying again." |
*
* @param {Widget_Support_Send_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_send_failed = /** @type {((inputs?: Widget_Support_Send_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Send_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_send_failed(inputs)
});
/**
* | output |
* | --- |
* | "Email sending is unavailable right now. Nothing was sent, and your request is kept." |
*
* @param {Widget_Support_Send_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_send_not_configured = /** @type {((inputs?: Widget_Support_Send_Not_ConfiguredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Send_Not_ConfiguredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_send_not_configured(inputs)
});
/**
* | output |
* | --- |
* | "{facts} · Snapshot: {time}" |
*
* @param {Widget_Support_SnapshotInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_snapshot = /** @type {((inputs: Widget_Support_SnapshotInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_SnapshotInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_snapshot(inputs)
});
/**
* | output |
* | --- |
* | "This store cannot receive requests here right now. Your request has not been sent." |
*
* @param {Widget_Support_Store_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_store_unavailable = /** @type {((inputs?: Widget_Support_Store_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Store_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_store_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Out of stock" |
*
* @param {Widget_Support_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_unavailable = /** @type {((inputs?: Widget_Support_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Request unavailable" |
*
* @param {Widget_Support_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_support_unavailable_title = /** @type {((inputs?: Widget_Support_Unavailable_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Support_Unavailable_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_support_unavailable_title(inputs)
});
/**
* | output |
* | --- |
* | "Contact page ·" |
*
* @param {Widget_Unavailable_Contact_PageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unavailable_contact_page = /** @type {((inputs?: Widget_Unavailable_Contact_PageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unavailable_Contact_PageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unavailable_contact_page(inputs)
});
/**
* | output |
* | --- |
* | "Copy summary" |
*
* @param {Widget_Unavailable_CopyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unavailable_copy = /** @type {((inputs?: Widget_Unavailable_CopyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unavailable_CopyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unavailable_copy(inputs)
});
/**
* | output |
* | --- |
* | "The store’s email isn’t available right now, so nothing was sent." |
*
* @param {Widget_Unavailable_MessageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unavailable_message = /** @type {((inputs?: Widget_Unavailable_MessageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unavailable_MessageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unavailable_message(inputs)
});
/**
* | output |
* | --- |
* | "Reach the store another way" |
*
* @param {Widget_Unavailable_Other_WayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unavailable_other_way = /** @type {((inputs?: Widget_Unavailable_Other_WayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unavailable_Other_WayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unavailable_other_way(inputs)
});
/**
* | output |
* | --- |
* | "Phone · {number}" |
*
* @param {Widget_Unavailable_PhoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unavailable_phone = /** @type {((inputs: Widget_Unavailable_PhoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unavailable_PhoneInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unavailable_phone(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t send your request" |
*
* @param {Widget_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unavailable_title = /** @type {((inputs?: Widget_Unavailable_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unavailable_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unavailable_title(inputs)
});
/**
* | output |
* | --- |
* | "Unsent request" |
*
* @param {Widget_Unsent_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unsent_label = /** @type {((inputs?: Widget_Unsent_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unsent_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unsent_label(inputs)
});
/**
* | output |
* | --- |
* | "Resume request" |
*
* @param {Widget_Unsent_ResumeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unsent_resume = /** @type {((inputs?: Widget_Unsent_ResumeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unsent_ResumeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unsent_resume(inputs)
});
/**
* | output |
* | --- |
* | "{type} · Not sent" |
*
* @param {Widget_Unsent_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unsent_status = /** @type {((inputs: Widget_Unsent_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unsent_StatusInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unsent_status(inputs)
});
/**
* | output |
* | --- |
* | "Request to the store" |
*
* @param {Widget_Unsent_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_unsent_title = /** @type {((inputs?: Widget_Unsent_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Unsent_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_unsent_title(inputs)
});
/**
* | output |
* | --- |
* | "Digit {index} of {length}" |
*
* @param {Widget_Verification_Code_DigitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_code_digit = /** @type {((inputs: Widget_Verification_Code_DigitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Code_DigitInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_code_digit(inputs)
});
/**
* | output |
* | --- |
* | "Verification code" |
*
* @param {Widget_Verification_Code_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_code_label = /** @type {((inputs?: Widget_Verification_Code_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Code_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_code_label(inputs)
});
/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Widget_Verification_Request_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_request_action = /** @type {((inputs?: Widget_Verification_Request_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Request_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_request_action(inputs)
});
/**
* | output |
* | --- |
* | "Sign in to your store account. We’ll bring you back here to continue your question." |
*
* @param {Widget_Verification_Request_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_request_description = /** @type {((inputs?: Widget_Verification_Request_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Request_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_request_description(inputs)
});
/**
* | output |
* | --- |
* | "This sign-in request is no longer active. Ask to check your order again." |
*
* @param {Widget_Verification_Request_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_request_expired = /** @type {((inputs?: Widget_Verification_Request_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Request_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_request_expired(inputs)
});
/**
* | output |
* | --- |
* | "Please wait…" |
*
* @param {Widget_Verification_Request_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_request_pending = /** @type {((inputs?: Widget_Verification_Request_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Request_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_request_pending(inputs)
});
/**
* | output |
* | --- |
* | "Sign in to check your order" |
*
* @param {Widget_Verification_Request_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verification_request_title = /** @type {((inputs?: Widget_Verification_Request_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verification_Request_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verification_request_title(inputs)
});
/**
* | output |
* | --- |
* | "This code has expired. Get a new code to continue." |
*
* @param {Widget_Verify_Code_ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_code_expired = /** @type {((inputs?: Widget_Verify_Code_ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Code_ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_code_expired(inputs)
});
/**
* | output |
* | --- |
* | "The code works for 10 minutes." |
*
* @param {Widget_Verify_Code_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_code_hint = /** @type {((inputs?: Widget_Verify_Code_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Code_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_code_hint(inputs)
});
/**
* | output |
* | --- |
* | "That code didn’t match. Check it and try again — {tries} tries left." |
*
* @param {Widget_Verify_Code_WrongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_code_wrong = /** @type {((inputs: Widget_Verify_Code_WrongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Code_WrongInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_code_wrong(inputs)
});
/**
* | output |
* | --- |
* | "That code didn’t match. Check it and try again — 1 try left." |
*
* @param {Widget_Verify_Code_Wrong_LastInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_code_wrong_last = /** @type {((inputs?: Widget_Verify_Code_Wrong_LastInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Code_Wrong_LastInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_code_wrong_last(inputs)
});
/**
* | output |
* | --- |
* | "Verify email" |
*
* @param {Widget_Verify_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_confirm = /** @type {((inputs?: Widget_Verify_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_confirm(inputs)
});
/**
* | output |
* | --- |
* | "Contact store" |
*
* @param {Widget_Verify_Contact_StoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_contact_store = /** @type {((inputs?: Widget_Verify_Contact_StoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Contact_StoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_contact_store(inputs)
});
/**
* | output |
* | --- |
* | "Email verification" |
*
* @param {Widget_Verify_Email_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_email_action = /** @type {((inputs?: Widget_Verify_Email_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Email_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_email_action(inputs)
});
/**
* | output |
* | --- |
* | "Enter a full email address, like name@example.com." |
*
* @param {Widget_Verify_Email_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_email_invalid = /** @type {((inputs?: Widget_Verify_Email_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Email_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_email_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Email used at checkout" |
*
* @param {Widget_Verify_Email_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_email_label = /** @type {((inputs?: Widget_Verify_Email_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Email_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_email_label(inputs)
});
/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Widget_Verify_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_email_placeholder = /** @type {((inputs?: Widget_Verify_Email_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Email_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_email_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "We couldn’t complete verification. Please try again." |
*
* @param {Widget_Verify_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_failed = /** @type {((inputs?: Widget_Verify_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_failed(inputs)
});
/**
* | output |
* | --- |
* | "We’ll email you a one-time code." |
*
* @param {Widget_Verify_IntroInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_intro = /** @type {((inputs?: Widget_Verify_IntroInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_IntroInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_intro(inputs)
});
/**
* | output |
* | --- |
* | "Too many attempts. Please wait before requesting another code." |
*
* @param {Widget_Verify_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_locked = /** @type {((inputs?: Widget_Verify_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_locked(inputs)
});
/**
* | output |
* | --- |
* | "Verify email" |
*
* @param {Widget_Verify_Playground_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_playground_action = /** @type {((inputs?: Widget_Verify_Playground_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Playground_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_playground_action(inputs)
});
/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Widget_Verify_ResendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_resend = /** @type {((inputs?: Widget_Verify_ResendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_ResendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_resend(inputs)
});
/**
* | output |
* | --- |
* | "Resend code in" |
*
* @param {Widget_Verify_Resend_InInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_resend_in = /** @type {((inputs?: Widget_Verify_Resend_InInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_Resend_InInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_resend_in(inputs)
});
/**
* | output |
* | --- |
* | "Send verification code" |
*
* @param {Widget_Verify_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_send = /** @type {((inputs?: Widget_Verify_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_send(inputs)
});
/**
* | output |
* | --- |
* | "Email verified" |
*
* @param {Widget_Verify_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_success = /** @type {((inputs?: Widget_Verify_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_success(inputs)
});
/**
* | output |
* | --- |
* | "Verify your email" |
*
* @param {Widget_Verify_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_title = /** @type {((inputs?: Widget_Verify_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_title(inputs)
});
/**
* | output |
* | --- |
* | "Email verification is unavailable. Please use store login." |
*
* @param {Widget_Verify_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_unavailable = /** @type {((inputs?: Widget_Verify_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "The email may have been sent. Enter the code if you received it, or resend after the cooldown." |
*
* @param {Widget_Verify_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_verify_unknown = /** @type {((inputs?: Widget_Verify_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Verify_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_verify_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Answering" |
*
* @param {Widget_Voice_AnsweringInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_answering = /** @type {((inputs?: Widget_Voice_AnsweringInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_AnsweringInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_answering(inputs)
});
/**
* | output |
* | --- |
* | "The voice connection closed." |
*
* @param {Widget_Voice_ClosedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_closed = /** @type {((inputs?: Widget_Voice_ClosedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_ClosedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_closed(inputs)
});
/**
* | output |
* | --- |
* | "Connecting to voice…" |
*
* @param {Widget_Voice_ConnectingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_connecting = /** @type {((inputs?: Widget_Voice_ConnectingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_ConnectingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Turn off voice" |
*
* @param {Widget_Voice_DisableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_disable = /** @type {((inputs?: Widget_Voice_DisableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_DisableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_disable(inputs)
});
/**
* | output |
* | --- |
* | "Use voice" |
*
* @param {Widget_Voice_EnableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_enable = /** @type {((inputs?: Widget_Voice_EnableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_EnableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_enable(inputs)
});
/**
* | output |
* | --- |
* | "Voice call ended. Turn voice on to continue." |
*
* @param {Widget_Voice_EndedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_ended = /** @type {((inputs?: Widget_Voice_EndedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_EndedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_ended(inputs)
});
/**
* | output |
* | --- |
* | "Voice error" |
*
* @param {Widget_Voice_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_error = /** @type {((inputs?: Widget_Voice_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_error(inputs)
});
/**
* | output |
* | --- |
* | "Listening" |
*
* @param {Widget_Voice_ListeningInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_listening = /** @type {((inputs?: Widget_Voice_ListeningInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_ListeningInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_listening(inputs)
});
/**
* | output |
* | --- |
* | "Voice is in use on another device." |
*
* @param {Widget_Voice_OccupiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_occupied = /** @type {((inputs?: Widget_Voice_OccupiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_OccupiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_occupied(inputs)
});
/**
* | output |
* | --- |
* | "Voice was taken over by another connection." |
*
* @param {Widget_Voice_ReplacedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_replaced = /** @type {((inputs?: Widget_Voice_ReplacedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_ReplacedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_replaced(inputs)
});
/**
* | output |
* | --- |
* | "Voice access was revoked for this device." |
*
* @param {Widget_Voice_RevokedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_revoked = /** @type {((inputs?: Widget_Voice_RevokedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_RevokedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_revoked(inputs)
});
/**
* | output |
* | --- |
* | "Sorry, I couldn't answer that. Please ask again." |
*
* @param {Widget_Voice_Turn_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const widget_voice_turn_failed = /** @type {((inputs?: Widget_Voice_Turn_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widget_Voice_Turn_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return __en.widget_voice_turn_failed(inputs)
});